/** @jsx jsx */
import * as React from "react";
import * as $ from "jquery";
import { css, jsx } from "@emotion/core"

import { connect } from "react-redux";
import {
    Goal,
    TrackableSymptomViewModel,
    UserGoalView,
    UserTrackableSymptomUpsertRequest
} from "@curefit/gmf-common";
import { IAddMetric, IMetricOptions } from "@curefit/metrics-common";
import {
    IMedicinePrescription,
    IMentalStatusExamination,
    IPatientAllergy,
    IPatientConcern,
    IPatientExamination,
    IPatientSurgeryAndProcedure,
    IPatientSystemiscExamination,
    IPatientSystemReview
} from "@curefit/ehr-common";
import { PatientPersonalProfile } from "@curefit/ups-common";
import {
    IAppointmentScheduleResponse,
    IDiagnosticLabTestItem,
    ILabtestPrescription,
    IPatientDetail,
    IPrescription,
    ISymptom,
} from "@curefit/care-common";
import { ModalComponent } from "../../components/ModalComponent";
import { PatientCompleteInfoActions } from "../../actions/PatientCompleteInfoActions";
import { default as AppUtils, LOADING_STATE, scrollElementToTop } from "../../utils/AppUtils";
import { isEmpty as _isEmpty, get as _get } from "lodash";
import IPatientCompleteInfo from "../../models/patients/IPatientCompleteInfo";
import { IOngoingConsultation } from "../../models/IOngoingConsultation";
import { OngoingConsultationActions } from "../../actions/OngoingConsultationActions";
import {
    DOCTOR_TYPES_FOR_APPOINTMENT,
    AppConstants,
    AppMessages,
    ConsultationStatusConstant,
    ForceCloseReason,
    metricIdsToFetchMetrics,
    ORION_IMG_URL,
    UI_TABS_ID,
    CONSULTATION_CHANNELS,
    toastNotificationAppearance,
    FeatureConfigValues,
    PrescriptionTabModes,
    prescriptionTabDefaultDoctorTypes,
    TabNames,
    DoctorType,
    APP_TENANTS,
    SUPPORTED_DOCTOR_TYPES_FOR_PACK_DETAILS
} from "../../utils/AppConstants";
import { ConsultationTabNames, TabConfig, TabManager } from "../../utils/TabManager"
import TabsHeader from "../../components/common/TabsHeader"
import { IAppState } from "../../models/IAppState";
import IDoctorProfile from "../../models/IDoctorProfile";
import { IPatientVitalResponse } from "../../models/IPatientVitalResponse";
import IVital from "../../models/staticData/IVital";
import IPatientVital from "../../models/IPatientVital";
import { AllStaticDataActions } from "../../actions/AllStaticDataActions";
import { IEHRSavePatientMedicalProfile, INewConfigData } from "../../models/patients/IEHRSavePatientMedicalProfile";
import { browserHistory } from "react-router";
import * as RouteConfigs from "../../routes";
import { IChatAndVideoTokens } from "../../models/ICommunication";
import IHabit from "../../models/staticData/IHabit";
import IAccountData from "../../models/IAccountData";
import IChiefComplaint from "../../models/IChiefComplaint";
import IPatientCondition from "../../models/IPatientCondition";
import IStaticData from "../../models/staticData/IStaticData";
import ModelFactory from "../../models/ModelFactory";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import IDifferentialDiagnosis from "../../models/IDifferentialDiagnosis";
import { AppointmentsActions } from "../../actions/AppointmentsActions";
import IinfoQues from "../../models/staticData/IinfoQues";
import IHabitStaticData from "../../models/staticData/IHabitStaticData";
import IRoutineActivity from "../../models/staticData/IRoutineActivities";
import RoutineAttribute from "../../models/staticData/RoutineAttribute";
import IMedicineType from "../../models/staticData/IMedicineType";
import ConsultationDelay from "../../components/ConsultationDelay";
import { ITypeFormResponse } from "../../models/ITypeFormResponse";
import VideoContainerWrapper from "../TeleConsultation/VideoContainerWrapper";
import PrivateNotesModal from "./PrivateNotesModal";
import IMentalStatusExaminationStaticDataValue from "../../models/staticData/IMentalStatusExaminationStaticDataValue";
import { MedicationActions } from "../../actions/MedicationActions";
import IMedicineSuggestions from "../../models/IMedicineSuggestions";
import ForceCloseConsultationWrapper from "../../components/ForceCloseConsultationWrapper";
import { TwilioActions } from "../../actions/TwilioActions";
import { LifestylePlanActions } from "../../actions/LifestylePlanActions";
import IFetchMealsByCaloriesRequest from "../../models/IFetchMealsByCaloriesRequest";
import IPatientLifestylePlanWrapper from "../../models/patients/IPatientLifestylePlanWrapper";
import IFoodCategory from "../../models/IFoodCategory";
import IMealItem from "../../models/IMealItem";
import IDishCatalogueResponse from "../../models/maverick/IDishCatalogueResponse";
import IMetric from "../../models/metrics/IMetric";
import IGenericPlanPrescriptionDetailObject from "../../models/gms/IGenericPrescriptionDetailObject";
// import PatientPersonalProfile from "../../models/patients/PatientPersonalProfile";
import IOrionPlanResponse from "../../models/orion/IOrionPlanResponse";
import IPrivateNotes from "../../models/IPrivateNotes";
import LogoutPrompt from "./LogoutPrompt";
import ReviewPdf from "./ReviewPdf";
import PdfSaveSuccessModal from "./PdfSaveSuccessModal";
import PdfSaveFailureModal from "./pdfSaveFailureModal";
import { ApiManager } from "../../api/ApiManager";
import { AlbusUrlConfigs } from "../../api/AlbusUrlConfigs";
import htmlDocTemplate from "../../PdfTemplates/prescription";
import { IConstituentTemplate, IPdfTemplates } from "../../models/PdfTemplatesModels";
import { Tracker } from "../../utils/Tracker";
import { EventNames, SectionContext, UnregisterKeys, FlowContext } from "../../utils/EventTrackerConstants";
import { MaskNumber } from "@curefit/care-rangoon-integration";
import moment = require("moment");
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import { IFeatureConfig } from "../../models/IFeatureConfig";
import TopBanner from "./TopBanner";
import CheckMediaDevices from "../../components/CheckMediaDevices"
import { FormTypes } from "../../models/UserForm";
import { getConsultationFeedbackFormData } from "../../actions/UserformActions";
import ActiveTabNavigation, { INavTabs } from "../../components/ongoing/ActiveTabNavigation/ActiveTabNavigation";
import { TreatmentPlanActions } from "../../actions/TreatmentPlanActions";
import { historyAndIntakeSectionConfiguration } from "../../SectionConfigurations/historyAndIntakeSectionConfiguration";
import { sessionNotesConfiguration } from "../../SectionConfigurations/sessionNotesConfiguration";
import CompleteConsultConfirmation from "../../components/ongoing/CompleteConsultConfirmation"
import IDoctorSpeciality from "../../models/IDoctorSpeciality";
import ConsultationUtils from "../../utils/ConsultationUtils";
import { GenericActions } from "../../actions/GenericActions";
import { ConsentParam } from "../../builder/ConsentParamBuilder";
import { param } from "jquery";
import { ConsentComponent } from "../../components/ongoing/ConsentComponent";
import { ConsentModal } from "../../components/ongoing/ConsentModal";
import { labTestStyles } from "../../styles/ongoing/labtests";
import { RouteUtils } from "../../routes";
import ErrorContainer from "../ErrorContainer";
import { WhatsAppChatActions } from "../../actions/WhatsAppChatActions";
import { WhatsAppPatientInfo } from "../../components/WhatsAppChatComponent";
import EndLCConsultation from "./EndLCConsultation";
import { IWhatsAppChatContext } from "../../models/IWhatsAppChatContext";
/**
 * Created by abhinav on 29/01/18.
 */



export interface OngoingConsultationContainerProps {
    consultationChannel: string;
    params: any,
    accountData: IAccountData,
    isCovidActivePack?: boolean,
    chatAndVideoAccessTokens: IChatAndVideoTokens,
    fetchStaticDiagnosticLabTests: () => Promise<any>,
    fetchPatientCompleteDetails: (patientId: number) => void,
    fetchPatientPastSessions: (patientId: number, subSectionKey: string) => Promise<any>,
    fetchOngoingConsultation: (patientId: number, appointmentId: number, curefitId: number, isSelf: boolean, doctorProfile: IDoctorProfile) => Promise<any>,
    clearOngoingConsultationDetails: () => void,
    getTreatmentPlans: (doctorId: number) => void,
    saveEditedPrescription: (prescription: IPrescription) => void,
    saveCurrentPrescription: (appointmentId: number, prescription: IPrescription) => Promise<IPrescription>,
    saveEditedAllergies: (allergies: IPatientAllergy[]) => void,
    saveEditedChiefComplaints: (chiefComplaints: IChiefComplaint) => void,
    saveEditedIllnesses: (illnesses: string) => void,
    saveEditedMedicalProfile: (patientMedicalProfile: IEHRSavePatientMedicalProfile) => void,
    saveEditedExaminations: (patientExaminations: IPatientExamination[]) => void,
    saveEditedSystemicExaminations: (patientSystemicExaminations: IPatientSystemiscExamination[]) => void,
    saveEditedMentalStatusExaminations: (mentalStatusExaminations: IMentalStatusExamination[]) => void,
    saveDifferentialDiagnosis: (appointmentId: number, differentialDiagnosis: IDifferentialDiagnosis) => Promise<any>,
    savePrivateNotes: (appointmentId: number, privateNotes: IPrivateNotes) => Promise<any>,
    updateAppointmentStatus: (bookingId: number, appointmentId: number, status: ConsultationStatusConstant) => Promise<any>,
    forceCompleteAppointment: (status: string, bookingId: number, appointmentId: number, reasonCode: ForceCloseReason, reasonText: string, missedReasonCode?: MISSED_REASON_CODE) => Promise<any>,
    getIsActiveCovidPack: (userId: number) => Promise<any>,
    uploadPrescription: (appointmentId: number, prescription: File, type: string) => Promise<any>,
    uploadPlan: (appointmentId: number, plan: File, type: string) => Promise<any>,
    patientConditions: IPatientCondition[],
    patientConcerns: IPatientConcern[],
    patientRedFlags: IStaticDataValue[],
    patientSurgeries: IPatientSurgeryAndProcedure[],
    patientAllergies: IPatientAllergy[],
    patientHabits: IHabit[],
    patientCurrentMedication: IMedicinePrescription[],
    patientSymptoms: ISymptom[],
    patientDetails: IPatientCompleteInfo,
    doctorProfile: IDoctorProfile,
    patientVitals: IPatientVitalResponse[],
    patientGeneralExaminations: IPatientExamination,
    patientSystemicExaminations: IPatientExamination,
    staticVitalList: IVital[],
    staticMedicineTypes: IMedicineType[],
    staticSpecialities: IDoctorSpeciality[],
    staticConditions: IStaticData,
    getConsultationFeedbackUserFormData: (userId: number) => Promise<any>,
    staticRedFlags: IStaticDataValue[],
    staticGeneralExams: IStaticDataValue[],
    staticSystemicExams: IStaticDataValue[],
    staticEntExams: IStaticDataValue[],
    staticMentalStatusExaminations: { [key: string]: IMentalStatusExaminationStaticDataValue },
    staticReviewSystemsData: IStaticDataValue[],
    fetchPatientVitals: (patientId: number, userId: number, metricIds: number[]) => any,
    savePatientVitals: (patientId: number, patientVitals: IPatientVital[]) => any,
    fetchAllStaticData: () => any,
    fetchPlanStaticData: () => any,
    savePatientMedicalProfile: (patientId: number, patientMedicalProfile: IEHRSavePatientMedicalProfile, appointmentId: number, doctorType?: string) => Promise<any>,
    savePatientMedicalProfileSuccess: (patientId: number, patientMedicalProfile: IEHRSavePatientMedicalProfile) => Promise<any>,
    savePatientAllergies: (patientId: number, patientAllergies: IPatientAllergy[]) => Promise<any>,
    ongoingConsultation: IOngoingConsultation,
    fetchStaticSymptomsData: (input: string) => Promise<any>,
    fetchStaticDiseaseData: (input: string) => Promise<any>,
    fetchStaticLabTestsData: (input: string) => Promise<any>,
    fetchStaticLifeStyleData: (input: string) => Promise<any>,
    pastConsultations: IAppointmentScheduleResponse[],
    staticPersonalInfo: IinfoQues,
    staticPersonalInfoPhysiotherapist: IinfoQues,
    staticMindfulnessInfo: IinfoQues,
    staticFitnessRecallInfo: IinfoQues,
    staticFoodTypes: IStaticDataValue[],
    staticCuisines: IStaticDataValue[],
    staticPatientHabits: IHabitStaticData,
    saveEditedPersonalProfile: (personalInfo: PatientPersonalProfile) => void,
    updatePatientProfileData: (id: string, profile: PatientPersonalProfile) => Promise<any>;
    routineActivities: IRoutineActivity[];
    fetchStaticRoutineAttributes: () => Promise<RoutineAttribute>;
    patientTypeFormData: ITypeFormResponse;
    typeFormMapping: any;
    fetchFitnessActivitiesByName: (input: string) => Promise<any>;
    fetchMindfulnessActivitiesByName: (input: string) => Promise<any>;
    staticFoodGroups: IFoodCategory[];
    fetchStaticFoodGroups: () => Promise<IFoodCategory[]>;
    fetchMealsByCalorie: (
        calorieBreakup: IFetchMealsByCaloriesRequest
    ) => Promise<IMealItem[]>;
    saveAllProfilesForPatient: (
        curefitUserId: number,
        patientId: number,
        isSelf: boolean,
        allProfiles: PatientPersonalProfile
    ) => Promise<any>;
    savePatientPlanInDraft: (
        consultationId: number,
        patientPlan: IOrionPlanResponse
    ) => Promise<any>;
    launchPatientPlan: (patientId: number, req: any) => Promise<any>;
    launchPatientGoals: (patientId: number, req: any) => Promise<any>;
    saveEditedPatientPlan: (patientPlan: IPatientLifestylePlanWrapper) => void;
    saveEditedPatientGoals: (patientGoals: UserGoalView[]) => void;
    saveEditedPatientSecondaryGoals: (patientGoals: UserGoalView[]) => void;
    saveReviewOfSystemsData: (data: IPatientSystemReview[]) => void;
    fetchMedicineByGenericName: (name: string) => Promise<IMedicineSuggestions[]>;
    updateCurrentChannelWithPatient: (
        channelSid: string,
        patient: IPatientDetail,
        identity: string
    ) => void;
    clearCurrentChannel: () => void;
    connectionStrengthMessage: string;
    staticLifestyleHabits: IStaticData;
    fetchDishByDishName: (input: string) => Promise<IDishCatalogueResponse[]>;
    savePatientGoals: (
        patientId: number,
        patientGoals: UserGoalView[]
    ) => Promise<any>;
    fetchMealByMealId: (mealId: string) => Promise<IMealItem>;
    previewMeal: (meal: IMealItem) => Promise<IMealItem>;
    createMeal: (meal: IMealItem) => Promise<IMealItem>;
    staticGoals: Goal[];
    staticMetrics: IMetric[];
    fetchStaticDietGuidelines: (
        input: string,
        category: string
    ) => Promise<any[]>;
    savePatientGoalsEdit: (patientId: number, req: any) => Promise<any>;
    staticTrackableSymptoms: TrackableSymptomViewModel[];
    saveEditedPatientTrackableSymptoms: (
        trackableSymptoms: UserTrackableSymptomUpsertRequest[]
    ) => void;
    savePatientTrackableSymptoms: (
        userId: number,
        reqData: UserTrackableSymptomUpsertRequest[]
    ) => Promise<any>;
    deletePatientTrackableSymptoms: (
        userId: number,
        reqData: UserTrackableSymptomUpsertRequest[]
    ) => Promise<any>;
    addUserMetric: (
        userId: string,
        patientId: number,
        isSelf: boolean,
        metricId: string,
        metricValue: number
    ) => Promise<any>;
    getUserMetrics: (req: IMetricOptions) => void;
    orionClientLogger: (err: any) => void;
    savePatientPlan: (
        consultation: IAppointmentScheduleResponse,
        prescription: IPrescription,
        patientPlan: IPatientLifestylePlanWrapper | INewConfigData,
        planId: string,
        isSelf?: boolean,
        medicalProfile?: any
    ) => Promise<any>;
    removeWorkflowObject: (
        consultation: IAppointmentScheduleResponse,
        isPrescriptionObject: boolean
    ) => Promise<any>;
    uiConfiguration: any[];
    savePatientDiagnosticLabTests(req: IAddMetric): Promise<any>;
    savePatientLabTestsSuccess(dataObj: object): Promise<any>;
    savePatientLabTests(patientLabTests: any): void;
    labTests: any,
    diagnosticLabTests: ILabtestPrescription[],
    manualLabTests: IDiagnosticLabTestItem[]
    updateDiagnosticLabTests: (diagnosticLabTests: any) => void,
    saveManualLabTests: (diagnosticLabTests: IDiagnosticLabTestItem[]) => void,
    saveEditedPatientLabTests: (diagnosticLabTests: any) => void,
    saveChiefPatientPlans: () => void;
    staticPatientPlanEligibilityMaskAnswers: IStaticData[];
    updatePatientPlanEligibilityMasks: (userId: String, secondaryUserId: String, isSelf: Boolean, eligibilityMasks: String[]) => Promise<any>,
    deletePatientDiagnosticLabTests: (deletedLabTestIds: number[]) => Promise<any>,
    className: string,
    onAddNewItem: () => void,
    addSymptomForReview: (name: string) => Promise<any>,
    responseData: boolean,
    fetchConsultationPdfTemplates: (appointmentSchedule: IAppointmentScheduleResponse) => Promise<IConstituentTemplate>,
    pdfTemplates: IPdfTemplates,
    suggestions: { [key: string]: any }
    modalResponse: any,
    updatePatientMedicalProfile: (medicalProfile: any, subSectionKey: string) => Promise<any>,
    getMedicalProfile: (patientId: number, appointmentId: number, doctorType: string) => Promise<any>,
    fetchPastConsultationData: (consultationId: string, doctorType: string, patientId: string) => Promise<any>
    updateCurrentConsultationData: (medicalProfile: IEHRSavePatientMedicalProfile) => void
    fetchDataOnSelect: (doctorId: number, diagnosis?: Array<string>) => void
    featureConfigInfo: IFeatureConfig;
    fetchDoctorAppointments(doctorId: number, startTimeEpoch: number, numOfDays: number, isForPoll?: boolean, tillTimeEpoch?: number): Promise<any>;
    allAppointments: IAppointmentScheduleResponse[],
    fetchAccessPolicyForCurrentUser(params: ConsentParam): Promise<any>;
    setAccessPolicyForCurrentUser(params: ConsentParam): Promise<any>;
    fetchRelatedUsers(userId: string): Promise<any>;
    fetchChatContext: (appointmentId: number, commUserId: number) => null,
    updateWhatsAppChatContext: (patientInfo: WhatsAppPatientInfo) => void,
    closeWhatsAppChat: () => void,
    whatsAppChatContext: IWhatsAppChatContext
}

interface IScrollEvents {
    unit: number,
    startPoint?: number,
    endPoint?: number
}

export interface OngoingConsultationContainerState {
    consultationDetailsLoadingState: LOADING_STATE,
    differentialDiagnosisSavingState: LOADING_STATE,
    activeTab: TabConfig,
    allTabs: TabConfig[],
    modalStatus: boolean,
    modalScreen: string,
    modalErrorText: string,
    prescriptionSaveError?: string,
    planSaveError?: string,
    activeTabIdx: number,
    activeSubTabIdx?: number,
    isVideoExpanded: boolean,
    delayContainer: boolean,
    triggeredIn?: number,
    consultationStatusUpdated?: boolean,
    pdfData: File,
    pdfPreviewData: File,
    isPdfDataSaved: boolean,
    forceCloseModal: boolean,
    isCurrentChannelUpdatedInStore: boolean,
    planPdfData: File,
    planPdfPreviewData: File,
    errorMessage: string,
    secondModal: boolean,
    hasFetchedTemplates: boolean,
    hasFetchedTreatmentPlan: boolean,
    isConsnentComponentVisible: boolean,
    isConsentConfirmationModalVisible: boolean;
    activeSubSection: string,
    isOngoingContainerVisible: boolean,
    consultationStartedStatusUpdateFailed: boolean;
}

export const MODAL_SCREENS = {
    // PRESCRIPTION MODALS
    1: "REVIEW",
    2: "SUCCESS",
    3: "FAILURE",
    4: "NOTES",
    // PLAN MODALS
    5: "REVIEW_PLAN",
    6: "PLAN_SAVE_SUCCESS",
    7: "PLAN_SAVE_FAILURE",
    8: "UPLOADING_PDF",
    9: "LOGOUT_SCREEN",
    10: "CONFIRM_COMPLETE",
    11: "NO_REVIEW_END"
};

class OngoingConsultationContainer extends React.Component<
    OngoingConsultationContainerProps,
    OngoingConsultationContainerState
> {
    private tabDOM: any;
    private autoSaveTimer: any;
    private monitorScrollWidgetSubSectionKeys: any[];
    private loadStartTime: number = new Date().getTime();
    private pollInterval: any;

    private scrollEvents: IScrollEvents = {
        unit: 0
    };

    constructor(props: OngoingConsultationContainerProps) {
        super(props);
        this.state = {
            ...this.getStateFromProps(props),
            modalScreen: MODAL_SCREENS["1"],
            modalStatus: false,
            modalErrorText: "",
            // activeTabIdx: 0,
            isVideoExpanded: AppUtils.getIsMobile(),
            differentialDiagnosisSavingState: LOADING_STATE.NOT_INITIALIZED,
            consultationDetailsLoadingState: LOADING_STATE.NOT_INITIALIZED,
            delayContainer: false,
            consultationStatusUpdated: false,
            pdfData: null,
            pdfPreviewData: null,
            isPdfDataSaved: null,
            forceCloseModal: false,
            isCurrentChannelUpdatedInStore: false,
            planPdfData: null,
            planPdfPreviewData: null,
            errorMessage: null,
            secondModal: false,
            hasFetchedTemplates: false,
            hasFetchedTreatmentPlan: false,
            isOngoingContainerVisible: true,
            isConsnentComponentVisible: false,
            isConsentConfirmationModalVisible: false,
            activeSubSection: null,
            consultationStartedStatusUpdateFailed: false
        };
    }

    checkisOngoingPresent = (props: OngoingConsultationContainerProps) => {
        const isOnGoingEmpty: boolean = props.ongoingConsultation && Object.keys(props.ongoingConsultation).length > 0;
        return isOnGoingEmpty;
    }

    componentWillReceiveProps(nextProps: OngoingConsultationContainerProps) {
        this.setState(this.getStateFromProps(nextProps));
        const isOngoingPresentInCurrentProps: boolean = this.checkisOngoingPresent(this.props);
        const isOngoingPresentInNextProps: boolean = this.checkisOngoingPresent(nextProps);
        if (isOngoingPresentInCurrentProps !== isOngoingPresentInNextProps) {
            this.checkForConsent(nextProps.ongoingConsultation);
        }
    }

    checkForConsent = (ongoingConsultation: IOngoingConsultation) => {
        const { appointmentSchedule: { patient } } = ongoingConsultation;
        const isPsychiatristConsultation: boolean = ongoingConsultation.appointmentSchedule.doctorType === DOCTOR_TYPES_FOR_APPOINTMENT.PSYCHIATRIST;


        if (patient.relationship === "Self" || !isPsychiatristConsultation) return;
        const params: ConsentParam = new ConsentParam(patient);
        this.props.fetchAccessPolicyForCurrentUser(params)
            .then(res => {
                if (!res) {
                    this.setState({ isConsnentComponentVisible: true });
                }
            })
            .catch(err => {
                console.log(err)
            });
    }
    componentDidMount() {
        this.monitorScrollWidgetSubSectionKeys = [];
        const userId = this.getCurefitUserId();
        this.props.getIsActiveCovidPack(userId);
        this.props.getTreatmentPlans(this.props.doctorProfile.id);
        if (this.state.consultationDetailsLoadingState === LOADING_STATE.NOT_INITIALIZED && _isEmpty(this.props.ongoingConsultation)) {
            // consultationDetailsLoadingState = LOADING_STATE.LOADING;
            let isSelf = this.props.patientDetails.profile.relationship && this.props.patientDetails.profile.relationship.toUpperCase() === AppConstants.patientRelationships.SELF;
            this.props.fetchOngoingConsultation(
                this.getConsultationId(),
                this.getPatientId(),
                this.getCurefitUserId(),
                isSelf,
                this.props.doctorProfile,

            );
        }
        Tracker.register({
            flow: EventNames.Consultation,
            consultationId: this.props.params.consultationId
        })
        /* Tracker.track(EventNames.Page_Load) */
        Tracker.time_event(EventNames.OngoingConsultation);
        window.onbeforeunload = function (e: any) {
            let dialogText = "Are you sure?";
            e.returnValue = dialogText;
            return dialogText;
        };

        /*   window.onload = function () {
               const loadTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
               console.log("Page load time is " + loadTime);
           }*/
        this.showNextConsAlert();
        this.pollInterval = setInterval(() => {
            this.showNextConsAlert();
        }, AppConstants.IN_APP_NOTIFICATION.POLL_INTERVAL_IN_MS)
    }

    showNextConsAlert = () => {
        if (this.props.ongoingConsultation && this.props.ongoingConsultation.appointmentSchedule
            && this.props.doctorProfile) {
            const currentAppointmentEndTime = new Date().getTime();
            this.props.fetchDoctorAppointments(
                this.props.doctorProfile.id,
                currentAppointmentEndTime,
                null,
                true,
                currentAppointmentEndTime + AppConstants.IN_APP_NOTIFICATION.MIN_INTERVAL_BETWEEN_APPOINTEMENTS_FOR_ALERT
            ).then((nextAppointmentList: any) => {
                let nextAppointment: IAppointmentScheduleResponse = nextAppointmentList && nextAppointmentList[0];
                if (nextAppointment) {
                    let nextAppointmentStartTime = nextAppointment.startTime;
                    const intervalBetweenAppointments = nextAppointmentStartTime - currentAppointmentEndTime;
                    if (intervalBetweenAppointments <= AppConstants.IN_APP_NOTIFICATION.MIN_INTERVAL_BETWEEN_APPOINTEMENTS_FOR_ALERT) {
                        const nextPatientName: string = nextAppointment.patient.name;
                        AppUtils.showInAppNotification({
                            title: "Next Appointment",
                            subtitle: `With ${nextPatientName}`,
                            iconText: Math.floor(intervalBetweenAppointments / 60000),
                            isVisible: true,
                            ctas: [],
                            appointment: nextAppointment
                        });
                        clearInterval(this.pollInterval);
                    }
                }
            }).catch(e => {
                console.log(e);
            })
        }
    }

    componentDidUpdate(prevProps: OngoingConsultationContainerProps, prevState: OngoingConsultationContainerState) {
        if (this.state.activeTab && (this.state.activeTab.tabName !== (prevState.activeTab && prevState.activeTab.tabName)) && this.props.ongoingConsultation?.appointmentSchedule?.doctorType === DoctorType.MIND_THERAPIST) {
            this.monitorTabWidgetsScroll();
        }
        if (!this.state.hasFetchedTreatmentPlan) {
            this.getConsultationTreatmentPlan()
        }
    }


    componentWillUnmount() {
        Tracker.unregister(UnregisterKeys.flow)
        Tracker.unregister(UnregisterKeys.consultationId)
        Tracker.track(EventNames.OngoingConsultation, { "appointmentId": this.props.params.consultationId });
        window.onbeforeunload = null;
        this.props.clearCurrentChannel();
        this.props.closeWhatsAppChat();
        clearInterval(this.pollInterval)
        // this.props.clearOngoingConsultationDetails();
    }

    monitorTabWidgetsScroll = () => {
        const widgets = this.getNavigationTabs()
        this.monitorScrollWidgetSubSectionKeys = (widgets || []).map((widget: INavTabs) => widget.key);
    }

    updateCurrentWindowSizeOfScroll(event: any) {
        const elBottom = AppUtils.getDivVisibleHeight(event)
        this.scrollEvents = {
            unit: elBottom,
            startPoint: 0,
            endPoint: elBottom
        }
    }

    updateScrollEvents = (currentScrollValue: number) => {
        let { startPoint, endPoint, unit } = this.scrollEvents
        if (currentScrollValue < startPoint) {
            if (startPoint !== 0) {
                endPoint = endPoint - unit
                startPoint = startPoint - unit
            }
        } else {
            startPoint = endPoint
            endPoint = endPoint + unit
        }

        this.scrollEvents = {
            unit: unit,
            startPoint: startPoint,
            endPoint: endPoint
        }

        Tracker.track(EventNames.Scroll_Event, { section: this.state.activeTab && this.state.activeTab.tabName, scrollPosition: endPoint })
    }

    updateActiveTabSubSectionThroughScroll = () => {
        const sectionElements = this.monitorScrollWidgetSubSectionKeys.map((subSectionKey): HTMLElement => {
            return document.querySelector(`[data-section='${subSectionKey}']`)
        })
            ;

        for (let i = 0; i < sectionElements.length; i++) {
            const elementTop = sectionElements[i] && sectionElements[i].getBoundingClientRect().top;
            if (elementTop > 80 && elementTop < 180) {
                this.setActiveSubSection(sectionElements[i].dataset.section)
                break;
            }
        }
    }

    handleScroll = (event: any) => {
        if (this.monitorScrollWidgetSubSectionKeys && this.monitorScrollWidgetSubSectionKeys.length > 0) {
            requestAnimationFrame(this.updateActiveTabSubSectionThroughScroll);
        }
        const wrappedElement = document.getElementsByClassName("tab-content");
        const { unit, startPoint, endPoint } = this.scrollEvents
        if (!unit) {
            this.updateCurrentWindowSizeOfScroll(event)
        }

        if (wrappedElement && unit) {
            const visibleTop = AppUtils.getCurrentScrollPosition(event)
            if (visibleTop > endPoint || visibleTop < startPoint) {
                this.updateScrollEvents(visibleTop)
            }
        }
    }

    checkAndInitializeChatDetails = (
        currProps: OngoingConsultationContainerProps
    ): boolean => {
        let isChannelInfoUpdatedInStore =
            this.state !== undefined
                ? this.state.isCurrentChannelUpdatedInStore
                : false;
        if (
            !_isEmpty(currProps.ongoingConsultation) &&
            !_isEmpty(currProps.ongoingConsultation.appointmentSchedule)
        ) {
            if (!isChannelInfoUpdatedInStore) {
                let appointment = currProps.ongoingConsultation.appointmentSchedule;
                let channelSid =
                    !_isEmpty(appointment) &&
                        !_isEmpty(appointment.appointmentActionsWithContext) &&
                        !_isEmpty(
                            appointment.appointmentActionsWithContext.chatActionWithContext
                        ) &&
                        !_isEmpty(
                            appointment.appointmentActionsWithContext.chatActionWithContext
                                .context
                        ) &&
                        !_isEmpty(
                            appointment.appointmentActionsWithContext.chatActionWithContext
                                .context.twilioCommunicationMode
                        )
                        ? appointment.appointmentActionsWithContext.chatActionWithContext
                            .context.twilioCommunicationMode.modeSid
                        : null;
                let patient = appointment.patient;
                if (
                    AppUtils.shouldOpenChatWindowForConsultation(
                        appointment,
                        this.props.doctorProfile.id
                    )
                ) {

                    if (this.props.accountData?.appTenant === APP_TENANTS.SUGARFIT &&
                        this.props.doctorProfile.type === SUPPORTED_DOCTOR_TYPES_FOR_PACK_DETAILS.LIFESTYLE_COACH) {
                        const whatsAppdPatientInfo: WhatsAppPatientInfo = {
                            doctorId: this.props.doctorProfile.id,
                            name: this.props.patientDetails.profile.name,
                            mobileNo: this.props.patientDetails.profile.userPhoneNumber || this.props.patientDetails.profile.phoneNumber,
                        }
                        this.setWhatsAppContext(whatsAppdPatientInfo);
                    } else {
                        isChannelInfoUpdatedInStore = true;
                        const memberIdentity = channelSid && appointment.appointmentActionsWithContext.chatActionWithContext.context.twilioCommunicationMode.doctorTwilioUser
                            ? appointment.appointmentActionsWithContext.chatActionWithContext.context.twilioCommunicationMode.doctorTwilioUser.identity
                            : ""
                        this.props.updateCurrentChannelWithPatient(channelSid, patient, memberIdentity);
                    }
                }
            }
        }
        return isChannelInfoUpdatedInStore;
    };

    setWhatsAppContext = (patientInfo: WhatsAppPatientInfo) => {
        if (!this.props.whatsAppChatContext || !this.props.whatsAppChatContext.patientInfo || this.props.whatsAppChatContext.patientInfo.mobileNo !== patientInfo.mobileNo) {
            this.props.closeWhatsAppChat();
            this.props.updateWhatsAppChatContext(patientInfo);
        }
    }

    checkAndInitializeConsultationDetails = (
        currProps: OngoingConsultationContainerProps
    ): LOADING_STATE => {
        let consultationDetailsLoadingState =
            this.state !== undefined
                ? this.state.consultationDetailsLoadingState
                : LOADING_STATE.NOT_INITIALIZED;
        let ongoingConsultationIntegrity = AppUtils.checkIntegrityOfConsultation(
            currProps.ongoingConsultation,
            currProps.params.patientId,
            currProps.params.consultationId
        );
        if (
            !_isEmpty(currProps.ongoingConsultation) &&
            !_isEmpty(currProps.ongoingConsultation.appointmentSchedule) &&
            ongoingConsultationIntegrity && !this.state.consultationStartedStatusUpdateFailed
        ) {
            consultationDetailsLoadingState = LOADING_STATE.LOADED;
            this.checkAndUpdateAppointmentStatus();
        } else {
            if (!ongoingConsultationIntegrity) {
                this.props.clearOngoingConsultationDetails();
                this.props.orionClientLogger({
                    message: "ONGOING CONSULTATION INTEGRITY CHECK FAILED",
                    params: currProps.params,
                    appointment: currProps.ongoingConsultation.appointmentSchedule
                })
            }
            // if (consultationDetailsLoadingState === LOADING_STATE.NOT_INITIALIZED && _isEmpty(currProps.ongoingConsultation)) {
            //     consultationDetailsLoadingState = LOADING_STATE.LOADING;
            //     let isSelf = this.props.patientDetails.profile.relationship.toUpperCase() === AppConstants.patientRelationships.SELF;
            //     this.props.fetchOngoingConsultation(
            //         this.getConsultationId(),
            //         this.getPatientId(),
            //         this.getCurefitUserId(),
            //         isSelf,
            //         this.props.doctorProfile
            //     );
            // }
        }
        return consultationDetailsLoadingState;
    };

    getConsultationPdfTemplates = (appointmentSchedule: IAppointmentScheduleResponse) => {
        if (this.state && !this.state.hasFetchedTemplates) {
            this.setState({
                hasFetchedTemplates: true
            }, () => {
                this.props.fetchConsultationPdfTemplates(appointmentSchedule).catch(() => {
                    AppUtils.triggerToastNotification("Error: PDF Templates not found", toastNotificationAppearance.error)
                });
            });
        }
    }

    getConsultationTreatmentPlan = () => {
        if (!_isEmpty(this.props.ongoingConsultation.medicalProfile) &&
            AppUtils.isDefined((this.props.ongoingConsultation.medicalProfile.currentConsultationData.prescriptionDiagnosis))) {
            if (!_isEmpty(this.props.ongoingConsultation.medicalProfile.currentConsultationData.prescriptionDiagnosis.diagnosticsList)) {
                let diagnosisArray: any[] = [];
                this.props.ongoingConsultation.medicalProfile.currentConsultationData.prescriptionDiagnosis.diagnosticsList.map((diagnosis: any) => {
                    diagnosisArray = [...diagnosisArray, diagnosis.disease.internalValue]
                })
                this.props.fetchDataOnSelect(this.getDoctorId(), diagnosisArray)
            }
            this.setState({
                hasFetchedTreatmentPlan: true
            })
        }
    }

    checkAndUpdateAppointmentStatus = () => {
        let currProps = this.props;
        if (
            this.state &&
            !this.state.consultationStatusUpdated &&
            currProps.ongoingConsultation &&
            currProps.ongoingConsultation.appointmentSchedule &&
            currProps.ongoingConsultation.appointmentSchedule.status !==
            ConsultationStatusConstant.CONSULTATION_STARTED
        ) {
            this.setState(
                {
                    consultationStatusUpdated: true
                },
                () => {
                    if (![ConsultationStatusConstant.CONSULTATION_COMPLETED, ConsultationStatusConstant.COMPLETED, ConsultationStatusConstant.PRESCRIPTION_IN_DRAFT, ConsultationStatusConstant.PRESCRIPTION_GENERATED].includes(currProps.ongoingConsultation.appointmentSchedule.status as ConsultationStatusConstant)) {
                        currProps.updateAppointmentStatus(
                            currProps.ongoingConsultation.appointmentSchedule.bookingId,
                            this.getConsultationId(),
                            ConsultationStatusConstant.CONSULTATION_STARTED
                        ).then(() => {
                            this.setState({ consultationStartedStatusUpdateFailed: false });
                        }).catch((err) => {
                            this.setState({ consultationStartedStatusUpdateFailed: true, consultationDetailsLoadingState: LOADING_STATE.NOT_INITIALIZED });
                            console.error("Failed to update status to consultation started for consultation Id:", this.getConsultationId());
                        })
                    }
                }
            );
        }
    };

    getStateFromProps = (currProps: OngoingConsultationContainerProps) => {
        //TODO: add boolean for multi sub tabs and index for sub tab
        let allTabs: TabConfig[] = [];
        let activeTab: TabConfig = null;
        let activeTabIdx: number = this.state ? this.state.activeTabIdx : null
        let activeSubTabIdx: number = this.state ? this.state.activeSubTabIdx : null
        let consultationDetailsLoadingState = this.checkAndInitializeConsultationDetails(
            currProps
        );
        let isChannelInfoUpdatedInStore = this.checkAndInitializeChatDetails(
            currProps
        );
        if (consultationDetailsLoadingState === LOADING_STATE.LOADED) {
            const loadStartTime = this.loadStartTime
            // if (this.state && this.state.consultationDetailsLoadingState !== LOADING_STATE.LOADED && loadStartTime) {
            //     const pageLoadTime = new Date().getTime()
            //     const loadTimeInSec = ((pageLoadTime - loadStartTime) / 1000).toFixed(3)
            //     Tracker.track(EventNames.Page_Load, { flow: EventNames.Consultation, section: "", loadTime: Number(loadTimeInSec) })
            // }
            if (this.state && !this.state.hasFetchedTemplates) {
                this.getConsultationPdfTemplates(currProps.ongoingConsultation.appointmentSchedule);
            }
            let tabNames = TabManager.ConsultationToTabListMap[currProps.ongoingConsultation.uiTabs];
            allTabs = tabNames.map(function (tabName: ConsultationTabNames) {
                return TabManager.ConsultationTabConfig[tabName.valueOf()];
            });
            if (this.state && AppUtils.isDefined(activeTabIdx))
                activeTab = this.state.activeTab || (this.state.activeSubTabIdx && allTabs[this.state.activeTabIdx].childTabs[this.state.activeSubTabIdx]) || allTabs[this.state.activeTabIdx];
            else if (prescriptionTabDefaultDoctorTypes.indexOf(currProps.ongoingConsultation.uiTabs) > -1) {
                activeTabIdx = allTabs.length - 1
                activeTab = allTabs[activeTabIdx]
            } else {
                activeTabIdx = 0
                activeTab = allTabs[0];
            }
            AppUtils.dispachCustomeEvent(AppConstants.ONGOING_CONS_OPEN_EVENT, {});

        }

        return {
            consultationDetailsLoadingState: consultationDetailsLoadingState,
            isCurrentChannelUpdatedInStore: isChannelInfoUpdatedInStore,
            activeTab: activeTab,
            allTabs: allTabs,
            activeTabIdx
        };
    };

    getUserIdForPolaris = (): string => {
        let curefitUserId = this.getCurefitUserId().toString();
        if (this.props.patientDetails.profile.relationship && this.props.patientDetails.profile.relationship.toUpperCase() !== AppConstants.patientRelationships.SELF) {
            curefitUserId = curefitUserId.concat(`-${this.getPatientId()}`);
        }
        return curefitUserId;
    };

    getCurefitUserId = (): number => {
        return parseInt(this.props.patientDetails.profile.curefitUserId);
    };

    getDoctorId = () => {
        return this.props.ongoingConsultation && this.props.ongoingConsultation.appointmentSchedule && this.props.ongoingConsultation.appointmentSchedule.doctor
            ? this.props.ongoingConsultation.appointmentSchedule.doctor.id
            : null;
    }

    getPatientId = (): number => {
        let patientId = parseInt(this.props.params.patientId);
        if (
            !_isEmpty(this.props.ongoingConsultation) &&
            !_isEmpty(this.props.ongoingConsultation.appointmentSchedule)
        )
            patientId = parseInt(
                this.props.ongoingConsultation.appointmentSchedule.patient.id.toString()
            );
        return patientId;
    };

    getConsultationId = (): number => {
        let consultationId = parseInt(this.props.params.consultationId);
        if (
            !_isEmpty(this.props.ongoingConsultation) &&
            !_isEmpty(this.props.ongoingConsultation.appointmentSchedule)
        )
            consultationId = parseInt(
                this.props.ongoingConsultation.appointmentSchedule.id.toString()
            );
        return consultationId;
    };

    getBookingId = (): number => {
        return this.props.ongoingConsultation.appointmentSchedule.bookingId;
    };

    updateActiveTab = (activeTab: TabConfig, activeTabIdx: number) => {
        /* Tracker.track(EventNames.Page_Load) */
        this.setState({ activeTab: activeTab, activeTabIdx: activeTabIdx });
    };

    updateActiveSubTab = (activeTab: TabConfig, activeSubTabIdx: number) => {
        /* Tracker.track(EventNames.Page_Load) */
        this.setState({ activeTab: activeTab, activeSubTabIdx: activeSubTabIdx });
    };

    nextTab = () => {
        let nextTabIdx = this.state.allTabs.length === this.state.activeTabIdx + 1 ? 0 : this.state.activeTabIdx + 1;
        let nextTab = this.state.allTabs[nextTabIdx]
        this.setState({ activeTabIdx: nextTabIdx, activeTab: nextTab }, () => {
            $(".ongoing-consultation-main-cont").scrollTop(0);
        })
    }

    toggleModal = (
        flag: boolean,
        clearPdfData?: boolean,
        modalScreen?: string,
        errorMessage?: string
    ) => {
        this.setState({
            modalScreen:
                modalScreen !== undefined ? modalScreen : this.state.modalScreen,
            modalStatus: flag,
            pdfData:
                clearPdfData !== undefined && clearPdfData ? null : this.state.pdfData,
            pdfPreviewData:
                clearPdfData !== undefined && clearPdfData
                    ? null
                    : this.state.pdfPreviewData,
            errorMessage
        });
    };

    showDifferentialDiagnosisModal = () => {
        this.setState({
            modalScreen: MODAL_SCREENS[4],
            modalStatus: true,
            secondModal: false
        });
    };

    saveEditedPatientProfile = (
        patientPersonalProfile: PatientPersonalProfile
    ) => {
        this.props.saveEditedPersonalProfile(patientPersonalProfile);
    };

    getActiveTabProps() {
        let patientSymptomSet = !_isEmpty(this.props.ongoingConsultation.medicalProfile.currentConsultationData.chiefComplaints) ? this.props.ongoingConsultation.medicalProfile.currentConsultationData.chiefComplaints : this.props.ongoingConsultation.medicalProfile.oldConsultationData.chiefComplaints;
        let consultationType = !_isEmpty(this.props.ongoingConsultation.appointmentSchedule) ? this.props.ongoingConsultation.appointmentSchedule.rootBooking.subCategoryCode : null;
        let doctorType = !_isEmpty(this.props.ongoingConsultation.appointmentSchedule) ? this.props.ongoingConsultation.appointmentSchedule.consultationProduct.subServiceType : null;
        let personalProfileId = this.props.patientDetails && this.props.patientDetails.profile && this.props.patientDetails.profile.relationship === "Self" ? this.props.patientDetails.profile.curefitUserId : this.props.patientDetails.profile.curefitUserId + "-" + this.props.patientDetails.profile.id;
        let isSelf = this.props.patientDetails.profile.relationship && this.props.patientDetails.profile.relationship.toUpperCase() === AppConstants.patientRelationships.SELF;
        let currentPrescription = this.props.ongoingConsultation.currentPrescription

        if (currentPrescription === null && !AppUtils.isPhysiotherapist(doctorType)) {
            let reasonForVisit = (this.props.ongoingConsultation.appointmentSchedule && this.props.ongoingConsultation.appointmentSchedule.followUpConsultationId
                && this.props.ongoingConsultation.appointmentSchedule.followUpConsultationId !== -1)
                ? "Follow Up"
                : (this.props.ongoingConsultation.appointmentSchedule && this.props.ongoingConsultation.appointmentSchedule.rootBooking
                    && this.props.ongoingConsultation.appointmentSchedule.rootBooking !== null
                    && this.props.ongoingConsultation.appointmentSchedule.rootBooking.subCategoryCode === "HCU" || this.props.ongoingConsultation.appointmentSchedule.rootBooking.subCategoryCode === "HCU_PACK")
                    ? "HCU"
                    : "";
            currentPrescription = {
                ...currentPrescription,
                reasonForVisit,
                publicNotes: "",
                privateNotes: "",
                noPresentingIllness: false
            }
            this.props.saveEditedPrescription(currentPrescription)
        }
        let patientPastConditions = this.props.ongoingConsultation.medicalProfile && this.props.ongoingConsultation.medicalProfile.newConfigData && this.props.ongoingConsultation.medicalProfile.newConfigData.pastConditions && this.props.ongoingConsultation.medicalProfile.newConfigData.pastConditions.conditionsList
            ? this.props.ongoingConsultation.medicalProfile.newConfigData.pastConditions.conditionsList.map((pastData: any) => {
                return pastData.disease.displayValue;
            }) : null;


        const currentMedication = this.props.ongoingConsultation.medicalProfile
            ? this.props.ongoingConsultation.medicalProfile.currentConsultationData && this.props.ongoingConsultation.medicalProfile.currentConsultationData.currentMedication
                ? this.props.ongoingConsultation.medicalProfile.currentConsultationData.currentMedication
                : this.props.ongoingConsultation.medicalProfile.oldConsultationData && this.props.ongoingConsultation.medicalProfile.oldConsultationData.currentMedication
                    ? this.props.ongoingConsultation.medicalProfile.oldConsultationData.currentMedication
                    : {}
            : {};
        switch (this.state.activeTab.tabName) {
            case ConsultationTabNames.VITALS_AND_ALLERGIES:
                return TabManager.getPatientVitalsAndAllergiesTabProps(
                    this.getCurefitUserId(),
                    this.getConsultationId(),
                    this.getPatientId(),
                    this.nextTab,
                    this.props.staticVitalList,
                    this.props.fetchPatientVitals,
                    this.props.savePatientVitals,
                    this.props.fetchAllStaticData,
                    AppUtils.getEditedBy(this.props.accountData),
                    // this.props.ongoingConsultation.medicalProfile.allergies,
                    this.props.saveEditedAllergies,
                    this.props.savePatientMedicalProfile,
                    this.props.ongoingConsultation.medicalProfile.currentConsultationData.allergies,
                    this.props.patientTypeFormData,
                    this.props.typeFormMapping,
                    this.props.doctorProfile.name,
                    this.props.saveEditedMedicalProfile,
                    this.props.patientVitals,
                    this.props.ongoingConsultation.uiConfiguration,
                    metricIdsToFetchMetrics
                );
            case ConsultationTabNames.LAB_TESTS:
                return TabManager.getLabTestsTabProps(
                    this.getPatientId(),
                    this.getCurefitUserId(),
                    this.props.labTests,
                    this.nextTab,
                    this.props.fetchStaticDiagnosticLabTests,
                    this.props.savePatientDiagnosticLabTests,
                    this.props.savePatientLabTestsSuccess,
                    this.props.savePatientLabTests,
                    this.props.updateDiagnosticLabTests,
                    this.props.diagnosticLabTests,
                    this.props.saveEditedPatientLabTests,
                    this.props.deletePatientDiagnosticLabTests,
                    this.props.manualLabTests,
                    this.props.saveManualLabTests
                );
            case ConsultationTabNames.CHIEF_COMPLAINTS:
                return TabManager.getChiefComplaintsProps(this.getPatientId(), AppUtils.getEditedBy(this.props.accountData),
                    this.props.ongoingConsultation.medicalProfile.allergies, this.props.patientVitals,
                    this.props.ongoingConsultation.medicalProfile.currentConsultationData && _isEmpty(this.props.ongoingConsultation.medicalProfile.currentConsultationData.chiefComplaints) ?
                        this.props.ongoingConsultation.medicalProfile.oldConsultationData.chiefComplaints : this.props.ongoingConsultation.medicalProfile.currentConsultationData.chiefComplaints, this.props.fetchStaticSymptomsData, this.props.saveEditedChiefComplaints, this.props.savePatientMedicalProfile, this.nextTab, this.props.staticReviewSystemsData, this.props.saveReviewOfSystemsData, this.props.ongoingConsultation.medicalProfile.patientSystemReviews, this.getConsultationId(), doctorType,
                    this.props.saveEditedPrescription, currentPrescription, this.props.ongoingConsultation.appointmentSchedule, this.props.saveEditedMedicalProfile,
                    this.props.ongoingConsultation.medicalProfile, this.props.savePatientMedicalProfileSuccess, isSelf, this.props.ongoingConsultation.uiConfiguration,
                    this.props.addSymptomForReview, this.props.fetchPatientPastSessions, this.props.responseData, this.props.modalResponse, this.props.suggestions
                );

            case ConsultationTabNames.PHYSIO_CHIEF_COMPLAINTS:
                return TabManager.getPhysioChiefComplaintsProps(
                    this.getPatientId(),
                    AppUtils.getEditedBy(this.props.accountData),
                    this.props.ongoingConsultation.medicalProfile.allergies,
                    this.props.patientVitals,
                    patientSymptomSet,
                    this.props.fetchStaticSymptomsData,
                    this.props.saveEditedChiefComplaints,
                    this.props.saveEditedIllnesses,
                    this.props.savePatientMedicalProfile,
                    this.nextTab,
                    this.props.staticReviewSystemsData,
                    this.props.saveReviewOfSystemsData,
                    this.props.ongoingConsultation.medicalProfile.patientSystemReviews,
                    this.getConsultationId(),
                    doctorType,
                    this.props.suggestions
                );
            case ConsultationTabNames.HISTORY:
                return TabManager.getPatientHistoryTabProps(
                    this.getConsultationId(),
                    AppUtils.getEditedBy(this.props.accountData),
                    this.getPatientId(),
                    this.props.patientAllergies,
                    this.props.ongoingConsultation.medicalProfile.surgeryAndProcedures,
                    this.props.ongoingConsultation.medicalProfile.currentMedications,
                    this.nextTab,
                    this.props.savePatientMedicalProfile,
                    this.props.ongoingConsultation.medicalProfile.comorbidConditions,
                    this.props.staticConditions ? this.props.staticConditions.values : null,
                    this.props.ongoingConsultation.medicalProfile.concerns,
                    this.props.staticRedFlags,
                    this.props.staticMedicineTypes,
                    this.props.ongoingConsultation.medicalProfile.redFlags,
                    this.props.saveEditedMedicalProfile,
                    this.props.ongoingConsultation.medicalProfile,
                    this.props.pastConsultations,
                    this.props.staticPersonalInfo,
                    this.props.ongoingConsultation.patientPersonalProfile,
                    this.saveEditedPatientProfile,
                    this.props.saveAllProfilesForPatient,
                    this.getUserIdForPolaris(),
                    this.props.fetchStaticSymptomsData,
                    this.props.patientTypeFormData,
                    this.props.typeFormMapping,
                    this.props.fetchStaticDiseaseData,
                    this.props.fetchMedicineByGenericName,
                    this.props.ongoingConsultation.medicalProfile
                        .pastPsychiatricHistoryList,
                    doctorType,
                    this.props.savePatientMedicalProfileSuccess,
                    this.props.updatePatientProfileData,
                    isSelf,
                    this.getCurefitUserId(),
                    this.props.ongoingConsultation.uiConfiguration,
                    this.props.staticPatientHabits,
                    this.props.staticPersonalInfoPhysiotherapist,
                    this.props.className,
                    this.props.fetchPastConsultationData,
                    this.handleCompleteConsultConfirmation,
                    this.props.isCovidActivePack
                );
            case ConsultationTabNames.PHYSICAL_ASSESSMENT:
                return TabManager.getPhysicalAssessmentTabProps(
                    this.getConsultationId(),
                    this.getPatientId(),
                    AppUtils.getEditedBy(this.props.accountData),
                    this.nextTab,
                    this.props.savePatientMedicalProfile,
                    this.props.saveEditedMedicalProfile,
                    this.props.ongoingConsultation.medicalProfile,
                    this.props.ongoingConsultation.patientPersonalProfile,
                    this.saveEditedPatientProfile,
                    personalProfileId,
                    this.props.typeFormMapping,
                    doctorType,
                    this.props.patientTypeFormData,
                    this.props.ongoingConsultation.medicalProfile
                        .pastPsychiatricHistoryList,
                    this.props.updatePatientProfileData,
                    isSelf,
                    this.getCurefitUserId(),
                    this.props.ongoingConsultation.uiConfiguration,
                    this.props.doctorProfile,
                    this.props.fetchPatientPastSessions
                );

            case ConsultationTabNames.EXAMINATION:
                return TabManager.getPatientExaminationTabProps(
                    AppUtils.getEditedBy(this.props.accountData),
                    this.getConsultationId(),
                    this.getPatientId(),
                    this.props.patientVitals,
                    this.props.ongoingConsultation.medicalProfile.allergies,
                    this.props.ongoingConsultation.medicalProfile.examinations,
                    this.props.ongoingConsultation.medicalProfile
                        .patientSystemicExaminations,
                    this.props.staticGeneralExams,
                    this.props.staticSystemicExams,
                    this.props.saveEditedExaminations,
                    this.props.saveEditedSystemicExaminations,
                    this.props.savePatientMedicalProfile,
                    this.nextTab,
                    this.props.pastConsultations,
                    this.props.ongoingConsultation.medicalProfile
                        .mentalStatusExaminations,
                    this.props.staticMentalStatusExaminations,
                    this.props.saveEditedMentalStatusExaminations,
                    doctorType,
                    this.props.staticReviewSystemsData,
                    this.props.saveReviewOfSystemsData,
                    this.props.ongoingConsultation.medicalProfile.patientSystemReviews,
                    this.props.savePatientMedicalProfile,
                    this.props.saveEditedMedicalProfile,
                    this.props.ongoingConsultation.medicalProfile,
                    this.props.typeFormMapping,
                    isSelf,
                    this.props.ongoingConsultation.uiConfiguration,
                    this.props.doctorProfile,
                    this.props.fetchPatientPastSessions
                );

            case ConsultationTabNames.PRESCRIPTION:
                return TabManager.getPatientPrescriptionTabProps(
                    AppUtils.getEditedBy(this.props.accountData),
                    this.getPatientId(),
                    this.getConsultationId(),
                    consultationType,
                    this.props.patientVitals,
                    this.props.ongoingConsultation.medicalProfile.allergies,
                    this.props.ongoingConsultation.medicalProfile.currentConsultationData.chiefComplaints,
                    this.props.ongoingConsultation.medicalProfile.redFlags,
                    patientPastConditions,
                    _isEmpty(this.props.ongoingConsultation.medicalProfile.currentConsultationData.currentMedication) ?
                        this.props.ongoingConsultation.medicalProfile.oldConsultationData.currentMedication.medicationList :
                        this.props.ongoingConsultation.medicalProfile.currentConsultationData.currentMedication.medicationList,
                    this.props.ongoingConsultation.medicalProfile.currentConsultationData,
                    this.props.saveEditedPrescription,
                    this.props.fetchStaticDiseaseData,
                    this.props.fetchStaticLabTestsData,
                    this.props.fetchStaticLifeStyleData,
                    this.props.staticSpecialities,
                    this.props.staticMedicineTypes,
                    this.props.ongoingConsultation.uiConfiguration,
                    this.props.ongoingConsultation.medicalProfile,
                    isSelf,
                    this.getCurefitUserId().toString(),
                    this.props.savePatientMedicalProfile,
                    this.toggleModal,
                    doctorType,
                    this.props.updateAppointmentStatus,
                    this.props.saveEditedMedicalProfile,
                    this.getBookingId(),
                    this.nextTab,
                    this.updatePhysiotherapyPlanPdf,
                    this.props.suggestions,
                    metricIdsToFetchMetrics,
                    this.props.fetchPatientVitals,
                    this.props.updateCurrentConsultationData,
                    this.fetchDataOnSelect,
                    this.props.featureConfigInfo,
                    this.props.ongoingConsultation.appointmentSchedule,
                    PrescriptionTabModes.ONGOING
                );

            case ConsultationTabNames.VITALS:
                return TabManager.getPatientVitalsTabProps(
                    this.getCurefitUserId(),
                    this.getPatientId(),
                    this.props.patientVitals,
                    this.props.staticVitalList,
                    this.props.fetchPatientVitals,
                    this.props.savePatientVitals,
                    this.props.fetchAllStaticData,
                    metricIdsToFetchMetrics
                );

            case ConsultationTabNames.LIFESTYLE:
                return TabManager.getPatientLifestyleTabProps(
                    this.getPatientId(),
                    this.getCurefitUserId(),
                    this.props.ongoingConsultation.medicalProfile.concerns,
                    AppUtils.getEditedBy(this.props.accountData),
                    this.props.staticPersonalInfo,
                    this.props.staticPatientHabits,
                    this.props.ongoingConsultation.patientPersonalProfile,
                    this.saveEditedPatientProfile,
                    this.props.staticMindfulnessInfo,
                    this.props.staticFitnessRecallInfo,
                    this.props.fetchStaticSymptomsData,
                    this.props.routineActivities,
                    this.props.fetchStaticRoutineAttributes,
                    this.props.fetchFitnessActivitiesByName,
                    this.props.fetchMindfulnessActivitiesByName,
                    this.props.staticFoodTypes,
                    this.props.staticCuisines,
                    this.props.patientTypeFormData,
                    this.props.typeFormMapping,
                    this.props.saveAllProfilesForPatient,
                    this.props.fetchDishByDishName,
                    this.nextTab,
                    isSelf,
                    this.props.ongoingConsultation.appointmentSchedule
                );
            case ConsultationTabNames.LIFESTYLE_PLAN:
                return TabManager.getPatientLifestylePlanTabProps(
                    this.props.ongoingConsultation.appointmentSchedule,
                    this.getBookingId(),
                    this.getConsultationId(),
                    this.getPatientId(),
                    this.getCurefitUserId(),
                    AppUtils.getEditedBy(this.props.accountData),
                    consultationType,
                    null,
                    null,
                    [],
                    [],
                    this.props.fetchFitnessActivitiesByName,
                    this.props.fetchMindfulnessActivitiesByName,
                    this.props.staticFoodGroups,
                    this.props.fetchStaticFoodGroups,
                    this.props.fetchMealsByCalorie,
                    this.props.ongoingConsultation.patientPlan,
                    this.props.ongoingConsultation.planMeta,
                    this.props.saveEditedPatientPlan,
                    this.props.staticLifestyleHabits,
                    this.toggleModal,
                    this.props.fetchDishByDishName,
                    this.props.staticSpecialities,
                    this.props.fetchMealByMealId,
                    this.props.previewMeal,
                    this.props.createMeal,
                    this.props.ongoingConsultation.patientGoals,
                    this.props.ongoingConsultation.patientSecondaryGoals,
                    this.props.ongoingConsultation.patient_interventions,
                    this.props.fetchStaticDietGuidelines,
                    this.props.savePatientPlanInDraft,
                    this.props.updateAppointmentStatus,
                    doctorType,
                    this.nextTab,
                    this.props.doctorProfile,
                    isSelf,
                    this.getConsultationId(),
                    this.props.ongoingConsultation.patientPlanEligibilityInfo,
                    this.props.staticPatientPlanEligibilityMaskAnswers,
                    this.props.updatePatientPlanEligibilityMasks,
                    this.props.ongoingConsultation.medicalProfile.patientData.newConfigData,
                    this.props.staticGoals,
                    this.props.staticMetrics,
                    this.props.suggestions,
                    this.props.accountData.appTenant
                );
            case ConsultationTabNames.GOALS:
                return TabManager.getPatientGoalsTabProps(
                    this.getCurefitUserId(),
                    this.getPatientId().toString(),
                    this.props.doctorProfile.id,
                    this.getConsultationId(),
                    this.props.ongoingConsultation.patientGoals,
                    this.props.staticGoals,
                    this.props.staticMetrics,
                    this.props.fetchPlanStaticData,
                    this.props.saveEditedPatientGoals,
                    this.props.saveEditedPatientSecondaryGoals,
                    this.props.savePatientGoals,
                    this.props.savePatientGoalsEdit,
                    this.nextTab,
                    this.props.ongoingConsultation.patientPlan,
                    this.props.staticTrackableSymptoms,
                    this.props.ongoingConsultation.patientTrackableSymptoms,
                    this.props.saveEditedPatientTrackableSymptoms,
                    isSelf,
                    doctorType,
                    this.props.savePatientTrackableSymptoms,
                    this.props.deletePatientTrackableSymptoms,
                    this.addUserMetric,
                    this.props.getUserMetrics,
                    this.props.ongoingConsultation.patientMetrics
                );
            case ConsultationTabNames.MIND_PLAN:
                return TabManager.getPatientTherapistPlanTabProps(AppUtils.getEditedBy(this.props.accountData),
                    this.getPatientId(),
                    this.getCurefitUserId(),
                    this.getBookingId(),
                    this.getConsultationId(),
                    consultationType,
                    doctorType,
                    this.props.staticSpecialities,
                    this.props.staticMedicineTypes,
                    this.props.ongoingConsultation.patientPlan,
                    this.props.fetchStaticLabTestsData,
                    this.props.ongoingConsultation.patientGoals,
                    this.props.staticGoals,
                    this.props.fetchPlanStaticData,
                    this.props.saveEditedPatientPlan,
                    this.toggleModal,
                    this.props.updateAppointmentStatus,
                    this.props.fetchStaticSymptomsData,
                    this.props.fetchStaticDiseaseData,
                    this.props.ongoingConsultation.medicalProfile.redFlags,
                    this.props.staticReviewSystemsData,
                    this.props.ongoingConsultation.medicalProfile.patientSystemReviews,
                    this.getConsultationId(),
                    this.nextTab,
                    this.props.doctorProfile,
                    this.props.pastConsultations,
                    _isEmpty(this.props.ongoingConsultation.medicalProfile.oldConsultationData.currentMedication) ?
                        this.props.ongoingConsultation.medicalProfile.currentConsultationData.currentMedication.medicationList :
                        this.props.ongoingConsultation.medicalProfile.oldConsultationData.currentMedication.medicationList,
                    isSelf,
                    this.props.ongoingConsultation.uiConfiguration,
                    this.props.ongoingConsultation.medicalProfile,
                    this.props.fetchPatientPastSessions,
                    this.props.savePatientMedicalProfile,
                    this.props.ongoingConsultation.medicalProfile.currentConsultationData.chiefComplaints,
                    //  patientSymptomSet,
                    this.props.saveEditedMedicalProfile,
                    this.props.responseData,
                    this.props.modalResponse,
                    this.handleCompleteConsultConfirmation
                );

            case ConsultationTabNames.UPLOAD_PLAN:
                return TabManager.getPlanUploadTabProps(
                    AppUtils.getEditedBy(this.props.accountData),
                    this.getConsultationId(),
                    this.getPatientId(),
                    this.props.patientVitals,
                    this.props.ongoingConsultation.medicalProfile.allergies,
                    this.props.ongoingConsultation.medicalProfile.examinations,
                    this.props.ongoingConsultation.medicalProfile
                        .patientSystemicExaminations,
                    this.props.staticGeneralExams,
                    this.props.staticSystemicExams,
                    this.props.saveEditedExaminations,
                    this.props.saveEditedSystemicExaminations,
                    this.props.savePatientMedicalProfile,
                    this.nextTab,
                    this.props.pastConsultations,
                    this.props.ongoingConsultation.medicalProfile
                        .mentalStatusExaminations,
                    this.props.staticMentalStatusExaminations,
                    this.props.saveEditedMentalStatusExaminations,
                    doctorType,
                    this.props.staticReviewSystemsData,
                    this.props.saveReviewOfSystemsData,
                    this.props.ongoingConsultation.medicalProfile.patientSystemReviews,
                    this.props.savePatientMedicalProfile,
                    this.props.saveEditedMedicalProfile,
                    this.props.ongoingConsultation.medicalProfile,
                    this.props.typeFormMapping,
                    isSelf,
                    this.props.ongoingConsultation.uiConfiguration,
                    this.props.doctorProfile,
                    this.props.fetchPatientPastSessions,
                    this.toggleModal,
                    this.props.suggestions
                );

            case ConsultationTabNames.PATIENT_DATA:
                return TabManager.getPatientLifestyleTabProps(
                    this.getPatientId(),
                    this.getCurefitUserId(),
                    this.props.ongoingConsultation.medicalProfile.concerns,
                    AppUtils.getEditedBy(this.props.accountData),
                    this.props.staticPersonalInfo,
                    this.props.staticPatientHabits,
                    this.props.ongoingConsultation.patientPersonalProfile,
                    this.saveEditedPatientProfile,
                    this.props.staticMindfulnessInfo,
                    this.props.staticFitnessRecallInfo,
                    this.props.fetchStaticSymptomsData,
                    this.props.routineActivities,
                    this.props.fetchStaticRoutineAttributes,
                    this.props.fetchFitnessActivitiesByName,
                    this.props.fetchMindfulnessActivitiesByName,
                    this.props.staticFoodTypes,
                    this.props.staticCuisines,
                    this.props.patientTypeFormData,
                    this.props.typeFormMapping,
                    this.props.saveAllProfilesForPatient,
                    this.props.fetchDishByDishName,
                    this.nextTab,
                    isSelf,
                    this.props.ongoingConsultation.appointmentSchedule
                );
            case ConsultationTabNames.AGM:
                return TabManager.getAGMReportTabProps(false);
            case ConsultationTabNames.ADHERANCE:
                return TabManager.getAdheranceTabProps(false);
            case ConsultationTabNames.GLUCOSE:
                return TabManager.getGlucoseTabProps(false);

            default:
                return {};
        }
    }

    addUserMetric = (metricId: string, metricValue: number) => {
        let isSelf =
            this.props.patientDetails.profile && this.props.patientDetails.profile.relationship && this.props.patientDetails.profile.relationship.toUpperCase() ===
            AppConstants.patientRelationships.SELF;
        return this.props.addUserMetric(
            this.getCurefitUserId().toString(),
            this.getPatientId(),
            isSelf,
            metricId,
            metricValue
        );
    };

    navigateToDashboard = () => {
        browserHistory.push(RouteConfigs.DOC_DASHBOARD);
    };

    hideModalOnOutsideClick = () => {
        this.setState({
            modalStatus: false
        });
    };

    decideModalSize = (): string => {
        if (
            this.state.modalScreen === MODAL_SCREENS["1"] ||
            this.state.modalScreen === MODAL_SCREENS["5"]
        )
            return "full";
        else return "small";
    };

    toggleDelayContainer = (flag: boolean, time?: number) => {
        $(".consultation-delay-container .button-container a").addClass("blink");
        setTimeout(() => {
            $(".consultation-delay-container .button-container a").removeClass(
                "blink"
            );
        }, 6000);
    };

    onPrescriptionSaveFail = (
        errorText: string,
        isPdfDataSaved: boolean,
        pdfData: File,
        pdfPreviewData: File
    ) => {
        this.setState({
            modalScreen: MODAL_SCREENS[3],
            prescriptionSaveError: errorText,
            pdfData,
            pdfPreviewData,
            isPdfDataSaved
        });
    };

    onPrescriptionSaveSuccess = (pdfData: File, pdfPreviewData: File) => {
        this.setState({
            modalScreen: MODAL_SCREENS[2],
            pdfData,
            pdfPreviewData
        });
    };

    onPlanSaveFail = (
        errorText: string,
        isPdfDataSaved: boolean,
        pdfData: File,
        pdfPreviewData: File
    ) => {
        this.setState({
            modalScreen: MODAL_SCREENS[7],
            planSaveError: errorText,
            pdfData,
            pdfPreviewData,
            isPdfDataSaved
        });
    };

    onPlanSaveSuccess = (pdfData: File, pdfPreviewData: File) => {
        this.setState({
            modalScreen: MODAL_SCREENS[6],
            pdfData,
            pdfPreviewData
        });
    };

    toggleForceCloseModal = () => {
        let status = this.state.forceCloseModal;
        this.setState({
            forceCloseModal: !status
        });
    };

    forceCompleteAppointment = (
        status: string,
        reasonCode: ForceCloseReason,
        reasonText: string,
        missedReasonCode?: MISSED_REASON_CODE
    ) => {
        this.props
            .forceCompleteAppointment(
                status,
                this.getBookingId(),
                this.getConsultationId(),
                reasonCode,
                reasonText,
                missedReasonCode
            )
            .then(() => {
                this.navigateToDashboard();
            });
    };

    updatePhysiotherapyPlanPdf = (file: File) => {
        this.setState(
            {
                modalStatus: true,
                modalScreen: MODAL_SCREENS[8],
                planPdfData: file,
                planPdfPreviewData: file
            },
            this.savePhysioConsultation
        );
    };

    savePrescription = (consultation: any, prescription: any) => {
        let appointmentConsultation = this.props.ongoingConsultation
            .appointmentSchedule;
        let patientPrescription = this.props.ongoingConsultation
            .currentPrescription;
        return OngoingConsultationActions.savePatientPlanNew(
            appointmentConsultation,
            patientPrescription,
            null,
            null,
        );
    };

    savePhysioConsultation = () => {
        let prescription = this.props.ongoingConsultation.currentPrescription;
        if (!_isEmpty(prescription)) {
            this.savePrescription(
                this.props.ongoingConsultation.appointmentSchedule,
                prescription
            ).then(() => {
                this.uploadPhysiotherapyPdf();
            });
        } else {
            this.uploadPhysiotherapyPdf();
        }
    };

    uploadPhysiotherapyPdf = () => {
        const consultationId = this.getConsultationId();
        this.props
            .uploadPlan(
                consultationId,
                this.state.planPdfData,
                AppConstants.planPdfAttachmentType.EMAIL_ATTACHMENT
            )
            .then(data => {
                return this.props.uploadPlan(
                    consultationId,
                    this.state.planPdfPreviewData,
                    AppConstants.planPdfAttachmentType.PRINT_ATTACHMENT
                );
            })
            .then(() => {
                return this.props
                    .updateAppointmentStatus(
                        this.getBookingId(),
                        consultationId,
                        ConsultationStatusConstant.COMPLETED
                    )
                    .then(data => {
                        this.setState({
                            modalStatus: false,
                            secondModal: true,
                            modalScreen: MODAL_SCREENS[6]
                        });
                    });
            })
            .catch(err => {
                console.log(err);
                let errorMessage =
                    !_isEmpty(err) && !_isEmpty(err.message)
                        ? err.message
                        : AppMessages.PRESCRIPTION_PDF_SAVE_FAILURE;
                this.setState({
                    modalScreen: MODAL_SCREENS[7],
                    planSaveError: errorMessage
                });
            });
    };

    saveDifferentialDiagnosis = (
        appointmentId: number,
        differentialDiagnosis: IDifferentialDiagnosis
    ) => {
        // const isPlanAppointment = this.props.ongoingConsultation.appointmentSchedule.consultationProduct.hasPlan;
        // if (isPlanAppointment) {
        const privateNotes: IPrivateNotes = {
            caseSummary: differentialDiagnosis.notes
        };
        return this.props.savePrivateNotes(appointmentId, privateNotes);
        // } else {
        //     return this.props.saveDifferentialDiagnosis(appointmentId, differentialDiagnosis);
        // }
    };

    showLogoutPrompt = () => {
        this.toggleSecondModal(true)
        this.setState({ modalScreen: MODAL_SCREENS[1] });
    };

    toggleSecondModal = (value: boolean) => {
        this.setState({ secondModal: value });
    };

    getPdfHtmlContent = () => {
        console.log(document.getElementsByClassName("review-prescription-container")[0].innerHTML);
        return document.getElementsByClassName("review-prescription-container")[0]
            .innerHTML;


    };

    handlePdfPrint = () => {
        // Works with Chome, Firefox, IE, Safari
        // Get the HTML of div
        // let title = document.title;
        // let divElements = this.getPdfHtmlContent();
        let printWindow = window.open("", "_blank", "");
        // open the window
        printWindow.document.open();
        // write the html to the new window, link to css file
        // printWindow.document.write(
        //     "<html><head><title>" +
        //     title +
        //     "</title><link rel='stylesheet' type='text/css' href='/css/app.css'></head><body>"
        // );
        // printWindow.document.write(divElements);
        // printWindow.document.write("</body></html>");
        printWindow.document.write(this.getHTMLTemplate())

        printWindow.document.close();
        printWindow.focus();
        // The Timeout is ONLY to make Safari work, but it still works with FF, IE & Chrome.
        printWindow.onload = function () {
            setTimeout(function () {
                printWindow.print();
                printWindow.close();
            }, 300);
        };
    };

    getHTMLTemplate = (): string => {
        const template = this.getPdfHtmlContent().replace(
            /\/images/gi,
            `./dist/server/images`
        );
        const domain = window.location.origin;
        const htmlDoc = htmlDocTemplate
            .replace(/DOMAIN/gi, domain)
            .replace(`$injectBody`, template);
        return htmlDoc;
    };

    handleUploadPdf = () => {
        return ApiManager.getOrionApis().requestPdfGeneration(
            this.getHTMLTemplate(),
            ConsultationStatusConstant.COMPLETED,
            this.getBookingId(),
            this.getConsultationId(),
            this.props.ongoingConsultation.appointmentSchedule.consultationProduct.isPlan,
            AlbusUrlConfigs.getDoctorSigUrl(
                this.props.ongoingConsultation.appointmentSchedule.doctor
            )
        );
    };

    setActiveSubSection = (sectionName: string) => {
        this.setState({
            activeSubSection: sectionName
        })
    }

    handleNavigationTabSelect = (activeSubSection: string) => {
        const sectionElement = document.querySelector(`[data-section='${activeSubSection}']`);
        if (sectionElement) {
            scrollElementToTop(sectionElement as HTMLElement, document.querySelector(
                ".ongoing-consultation-main-cont"
            ) as HTMLElement, 100, 0, () => this.setActiveSubSection(activeSubSection))
        }
    }

    fetchDataOnSelect = (diagnosis?: Array<string>) => {
        this.props.fetchDataOnSelect(this.getDoctorId(), diagnosis)
    }

    onMaskClick = () => {
        LocalStorageUtils.setClickEvents({ field: "Join Call", section: EventNames.Call_Widget, widget: "Audio Call" })
    }

    savePrescriptionAsTemplate = () => {
        RouteConfigs.RouteUtils.navigateToHrefUrl(
            null,
            RouteConfigs.RouteUtils.getFromConsultTreatmentPlanUrl(
                this.getConsultationId().toString(),
                this.getPatientId().toString()
            )
        );
    }

    getNavigationTabs = () => {
        return [...historyAndIntakeSectionConfiguration, ...sessionNotesConfiguration].filter((widget: any) => {
            return widget.sectionKey === TabNames[this.state.activeTab.tabName]
        }).map((widget: any) => ({
            key: widget.subSectionKey,
            title: widget.subSectionTitle
        }))
    }

    handleCompleteConsultConfirmation = () => {
        this.setState({
            secondModal: false,
            modalStatus: true,
            modalScreen: MODAL_SCREENS["10"]
        })
    }

    closeModal = () => {
        this.setState({
            secondModal: false,
            modalStatus: false
        })
    }

    insertTagsUsedInTextEditorForSection = (data: any) => {
        const usedSuggestionsForEditorMap: { [key: string]: any } = _get(this.props.ongoingConsultation, "usedSuggestionsForEditorMap", {})
        Object.keys(usedSuggestionsForEditorMap).map((subSectionKey: string) => {
            if (!_isEmpty(data[subSectionKey])) {
                Object.keys(usedSuggestionsForEditorMap[subSectionKey]).map((questionKey: string) => {
                    data[subSectionKey][questionKey]["tags"] = usedSuggestionsForEditorMap[subSectionKey][questionKey]
                })
            }
        })
    }

    handleConfirmCompleteClick = async () => {
        const { ongoingConsultation } = this.props;
        const consultation = ongoingConsultation.appointmentSchedule;
        let patientPlan = ongoingConsultation.medicalProfile.currentConsultationData;
        this.insertTagsUsedInTextEditorForSection(patientPlan)
        try {
            await this.props.savePatientPlan(consultation, null, patientPlan, null)
            await this.props.updateAppointmentStatus(consultation.bookingId, consultation.id, ConsultationStatusConstant.COMPLETED)
            this.setState({
                modalStatus: false,
                secondModal: true
            })
        } catch (error) {
            let errorMsg = AppMessages.SAVE_PRESCRIPTION_UNSUCCESSFUL;
            if (!_isEmpty(error) && !_isEmpty(error.data)) {
                errorMsg += ": " + error.data.message;
            }
            console.log(error);
            AppUtils.triggerToastNotification(errorMsg, toastNotificationAppearance.error);
            this.setState({
                modalStatus: false,
            })
        }
    }

    hideOngoindContainerWhenForceCloseModalIsOpen = () => {
        // hanldes ios issue where force close modal is not properly visible
        if (AppUtils.getIsMobile()) {
            this.setState({ isOngoingContainerVisible: !this.state.isOngoingContainerVisible });
        }
    }
    toggleConsentCard = () => {
        this.setState({ isConsnentComponentVisible: !this.state.isConsnentComponentVisible });
    }

    toggleConsentConfirmationModal = () => {
        this.setState({ isConsentConfirmationModalVisible: !this.state.isConsentConfirmationModalVisible });
    }

    saveConsent = (hasGivenConsent: boolean) => {
        if (hasGivenConsent) {
            let consentParams: ConsentParam = new ConsentParam(this.props.ongoingConsultation.appointmentSchedule.patient, "EDIT", "USER");
            this.props.setAccessPolicyForCurrentUser(consentParams)
                .then(res => {
                    this.toggleConsentCard();
                    AppUtils.triggerToastNotification("Consent updated.", toastNotificationAppearance.success)
                })
                .catch(e => {
                    console.error(e);
                    this.toggleConsentCard();
                    AppUtils.triggerToastNotification("Failed to update consent.", toastNotificationAppearance.error)
                });
        } else {
            this.toggleConsentConfirmationModal();
        }

    }

    disallowConsent = () => {
        this.forceCompleteAppointment(ConsultationStatusConstant.MISSED, ForceCloseReason.NO_PATIENT_CONSENT, "Patient didn't give consent to continue consultation", MISSED_REASON_CODE.SYSTEM);
    }

    render() {
        const userId: string = this.props.ongoingConsultation &&
            this.props.ongoingConsultation.appointmentSchedule &&
            this.props.ongoingConsultation.appointmentSchedule.patient &&
            this.props.ongoingConsultation.appointmentSchedule.patient.curefitUserId;

        const phoneNumberOverride: string = this.props.ongoingConsultation &&
            this.props.ongoingConsultation.appointmentSchedule &&
            this.props.ongoingConsultation.appointmentSchedule.appointmentActionsWithContext &&
            this.props.ongoingConsultation.appointmentSchedule.appointmentActionsWithContext.audioActionWithContext &&
            this.props.ongoingConsultation.appointmentSchedule.appointmentActionsWithContext.audioActionWithContext.context &&
            this.props.ongoingConsultation.appointmentSchedule.appointmentActionsWithContext.audioActionWithContext.context.twilioCommunicationMode &&
            this.props.ongoingConsultation.appointmentSchedule.appointmentActionsWithContext.audioActionWithContext.context.twilioCommunicationMode.modeName;

        let myInstance = this;
        let doctorType =
            !_isEmpty(this.props.ongoingConsultation) &&
                !_isEmpty(this.props.ongoingConsultation.appointmentSchedule)
                ? this.props.ongoingConsultation.appointmentSchedule.consultationProduct
                    .subServiceType
                : null;
        let isComponentLoadedCompletely =
            myInstance.state.consultationDetailsLoadingState === LOADING_STATE.LOADED && myInstance.state.hasFetchedTemplates && !myInstance.state.consultationStartedStatusUpdateFailed;
        let modalScreen = this.state.modalScreen;
        let currentAppointment, currPatient, activeTabProps, ActiveTabComponent, sellableProductInfo, city,
            videoContext, isVideoAllowed = null;
        if (isComponentLoadedCompletely) {
            currentAppointment = this.props.ongoingConsultation.appointmentSchedule;
            currPatient = this.props.ongoingConsultation.appointmentSchedule.patient;
            ActiveTabComponent = this.state.activeTab.component;
            activeTabProps = this.getActiveTabProps();
            sellableProductInfo = this.props.ongoingConsultation.baseSellableProduct;
            videoContext = currentAppointment.appointmentActionsWithContext && currentAppointment.appointmentActionsWithContext.videoActionWithContext
                && currentAppointment.appointmentActionsWithContext.videoActionWithContext
                    .context; // added check where videoContext is null for audio consultation
        }
        let differentialDiagnosisObject = ModelFactory.createNewDifferentialDiagnosis();
        const { consultationChannel } = this.props;
        const isMobile = AppUtils.getIsMobile();
        const isMindTherapist = this.props.ongoingConsultation?.appointmentSchedule?.doctorType === DoctorType.MIND_THERAPIST;
        const consultationDurationTxt = currentAppointment && currentAppointment.startTime && currentAppointment.endTime &&
            moment(currentAppointment.startTime).format("HH.mm") + " - " + moment(currentAppointment.endTime).format("HH.mm");
        const packInfo = this.props.ongoingConsultation.appointmentSchedule && this.props.ongoingConsultation.appointmentSchedule.packInfo && ConsultationUtils.getPackDetails(this.props.ongoingConsultation.appointmentSchedule);
        const { isConsentConfirmationModalVisible, isConsnentComponentVisible } = this.state;
        const patientPhoneNumber: any = !_get(this.props.ongoingConsultation, 'appointmentSchedule.appointmentActionsWithContext.audioActionWithContext.context.twilioCommunicationMode.modeName', "");
        return (
            <div onScroll={this.handleScroll}>
                <FlowContext.Provider value={EventNames.Consultation}>
                    <SectionContext.Provider value={this.state.activeTab && this.state.activeTab.display}>

                        {isConsnentComponentVisible &&
                            <ConsentComponent patientName={"User"} saveConsent={this.saveConsent} />
                        }

                        {isConsentConfirmationModalVisible &&
                            <ConsentModal disallowConsent={this.disallowConsent} dismissModal={this.toggleConsentConfirmationModal} />
                        }

                        {isComponentLoadedCompletely && (
                            <div className="ongoing-consultation-cont">
                                <div className="ongoing-consultation-wrapper">
                                    <TopBanner
                                        toggleOngoingContainerVisiblility={this.hideOngoindContainerWhenForceCloseModalIsOpen}
                                        patient={currPatient}
                                        patientProfile={this.props.patientDetails.profile}
                                        baseSellableProduct={sellableProductInfo}
                                        appointmentSchedule={currentAppointment as any}
                                        forceCompleteAppointment={this.forceCompleteAppointment}
                                        renderOptions={{
                                            timer: true,
                                            phoneCall: true
                                        }}
                                        onTimerAlarm={this.toggleDelayContainer}
                                        TabsComponent={!isMobile && (<TabsHeader trackerEvents={{ flow: EventNames.Consultation, referenceID: this.getConsultationId().toString() }} tabs={this.state.allTabs} activeTab={this.state.activeTab}
                                            updateActiveTab={this.updateActiveTab} updateActiveSubTab={this.updateActiveSubTab} />)}
                                        prescriptionMode={PrescriptionTabModes.ONGOING}
                                    />
                                    {isMobile &&
                                        <div className="audio-mobile">
                                            <div className="audio-left">
                                                <div className="audio-text">
                                                    <img src="/images/audio.svg" alt="ongoing-video" />
                                                    <div>Audio Consultation</div>
                                                </div>
                                                <div className="duration-text">
                                                    <img src="/images/clock.svg" alt="cons-time" />
                                                    <div>{consultationDurationTxt}</div>
                                                </div>
                                                {packInfo &&
                                                    <React.Fragment>
                                                        <div className="appointment-pack-info">
                                                            <div>Sessions Booked</div>
                                                            <div><span className="brandon-bold">{packInfo.totalTicketsConsumed}</span> of {packInfo.totalTickets}</div>
                                                        </div>
                                                        <div className="appointment-pack-info">
                                                            <div>Pack Expiry</div>
                                                            <div><span className="brandon-bold">{AppUtils.getRelativeDay(packInfo.startEndEpoch.endEpoch, "D MMM Y")}</span></div>
                                                        </div>
                                                    </React.Fragment>

                                                }
                                            </div>
                                            <div className="audio-right">
                                                {phoneNumberOverride &&
                                                    <div onClick={this.onMaskClick}>
                                                        <MaskNumber className="call-btn-mobile" userId={userId} shouldShowNumber={false} phoneNumber={null} receiverPhoneNumber={phoneNumberOverride} meta={{ appointmentId: this.getConsultationId().toString() }} />
                                                    </div>
                                                }
                                                {!phoneNumberOverride &&
                                                    <div onClick={this.onMaskClick}>
                                                        <MaskNumber className="call-btn-mobile" receiverPhoneNumber={patientPhoneNumber} shouldShowNumber={false} phoneNumber={null} meta={{ appointmentId: this.getConsultationId().toString() }} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                    {this.props.connectionStrengthMessage &&
                                        <div className="weak-network">{this.props.connectionStrengthMessage}</div>}
                                    <div className="ongoing-consultation-main-cont">
                                        <div className={"consultation-details-container"} style={this.state.isOngoingContainerVisible ? {} : { display: "none" }}>
                                            {isMobile && (
                                                <TabsHeader tabs={this.state.allTabs} activeTab={this.state.activeTab}
                                                    updateActiveTab={this.updateActiveTab}
                                                    trackerEvents={{ flow: EventNames.Consultation, referenceID: this.getConsultationId().toString() }}
                                                />
                                            )}
                                            {!isMobile && isMindTherapist && (
                                                <ActiveTabNavigation
                                                    tabName={this.state.activeTab.tabName}
                                                    widgets={this.getNavigationTabs()}
                                                    onSelectTab={this.handleNavigationTabSelect}
                                                    activeSubSection={this.state.activeSubSection}
                                                />
                                            )}
                                            <div className={`tab-content ${isMindTherapist && "tab-content-nav"}`} css={this.state.activeTab && this.state.activeTab.tabName === "LAB_TESTS" ? labTestStyles.activeTabOverride : {}}>
                                                <ActiveTabComponent {...activeTabProps}
                                                    ref={(tabDOM: any) => this.tabDOM = tabDOM} />
                                            </div>
                                        </div>
                                        {!_isEmpty(videoContext) && (
                                            <VideoContainerWrapper
                                                ongoingConsultation={this.props.ongoingConsultation}
                                            />
                                        )}
                                        {(consultationChannel && consultationChannel === CONSULTATION_CHANNELS.AUDIO) &&
                                            <React.Fragment>
                                                {!isMobile &&
                                                    <div className="audio-channel-message video-container-wrapper collapsed">
                                                        <div className="message-text">
                                                            <div className="msg-title">Consult over phone</div>
                                                            <div className="msg-body">Patient has opted for a phone call</div>
                                                        </div>
                                                        <div className="audio-right adhoc-call" >
                                                            {phoneNumberOverride &&
                                                                <MaskNumber userId={userId} shouldShowNumber={false} phoneNumber={null} receiverPhoneNumber={phoneNumberOverride} meta={{ appointmentId: this.getConsultationId().toString() }} />
                                                            }
                                                            {!phoneNumberOverride &&
                                                                <MaskNumber receiverPhoneNumber={patientPhoneNumber} shouldShowNumber={false} phoneNumber={null} meta={{ appointmentId: this.getConsultationId().toString() }} />
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {isMobile &&
                                                    <div className="ongoing-video-strip">
                                                        <img src="/images/audio.svg" alt="ongoing-video" />
                                                        <span>User has opted for Audio call</span>
                                                        {phoneNumberOverride &&
                                                            <MaskNumber className="call-user" userId={userId} shouldShowNumber={false} phoneNumber={null} receiverPhoneNumber={phoneNumberOverride} meta={{ appointmentId: this.getConsultationId().toString() }} />
                                                        }
                                                        {!phoneNumberOverride &&
                                                            <MaskNumber className="call-user" receiverPhoneNumber={patientPhoneNumber} shouldShowNumber={false} phoneNumber={null} meta={{ appointmentId: this.getConsultationId().toString() }} />
                                                        }
                                                    </div>
                                                }
                                            </React.Fragment>
                                        }
                                    </div>
                                </div>

                                {this.state.modalStatus && (
                                    <ModalComponent modalSize={this.decideModalSize()}>
                                        {
                                            (modalScreen === MODAL_SCREENS["1"] || modalScreen === MODAL_SCREENS["5"]) &&
                                            <ReviewPdf
                                                appointmentId={this.getConsultationId()}
                                                doctorProfile={this.props.doctorProfile}
                                                doctorType={doctorType}
                                                patientId={this.getCurefitUserId()}
                                                secondaryUserId={this.getPatientId().toString()}
                                                bookingId={this.getBookingId()}
                                                ongoingConsultation={this.props.ongoingConsultation}
                                                patientVitals={this.props.patientVitals}
                                                staticSpecialities={this.props.staticSpecialities}
                                                staticlifestylePlanHabits={this.props.staticLifestyleHabits}
                                                toggleModal={this.toggleModal}
                                                onPlanSaveFail={this.onPlanSaveFail}
                                                onPlanSaveSuccess={this.onPlanSaveSuccess}
                                                launchPatientPlan={this.props.launchPatientPlan}
                                                launchPatientGoals={this.props.launchPatientGoals}
                                                updateAppointmentStatus={this.props.updateAppointmentStatus}
                                                patientProfile={this.props.patientDetails.profile}
                                                staticGoals={this.props.staticGoals}
                                                staticMetrics={this.props.staticMetrics}
                                                fetchPlanStaticData={this.props.fetchPlanStaticData}
                                                saveUserPlan={this.props.savePatientPlan}
                                                removeWorkflowObject={this.props.removeWorkflowObject}
                                                staticSystemicExams={this.props.staticSystemicExams}
                                                staticEntExams={this.props.staticEntExams}
                                                savePrescriptionNew={this.props.savePatientPlan}
                                                isPdfDataSaved={this.state.isPdfDataSaved}
                                                onPrescriptionSaveFail={this.onPrescriptionSaveFail}
                                                onPrescriptionSaveSuccess={this.onPrescriptionSaveSuccess}
                                                toggleSecondModal={this.toggleSecondModal}
                                                printPdf={this.handlePdfPrint}
                                                uploadPdfAndCompleteConsultation={this.handleUploadPdf}
                                                pdfTemplates={this.props.pdfTemplates}
                                                savePatientMedicalProfile={this.props.savePatientMedicalProfile}
                                            />
                                        }
                                        {/*{*/}
                                        {/*(modalScreen === MODAL_SCREENS["2"] || modalScreen === MODAL_SCREENS["6"]) &&*/}
                                        {/*<PdfSaveSuccessModal*/}
                                        {/*consultationId={this.getConsultationId()}*/}
                                        {/*patientDetails={this.props.patientDetails}*/}
                                        {/*ongoingConsultation={this.props.ongoingConsultation}*/}
                                        {/*pdfData={this.state.pdfPreviewData}*/}
                                        {/*toggleModal={this.toggleModal}*/}
                                        {/*showDifferentialDiagnosisModal={this.showDifferentialDiagnosisModal}*/}
                                        {/*/>*/}
                                        {/*}*/}
                                        {(modalScreen === MODAL_SCREENS["3"] ||
                                            modalScreen === MODAL_SCREENS["7"]) && (
                                                <PdfSaveFailureModal
                                                    bookingId={this.getBookingId()}
                                                    consultationId={this.getConsultationId()}
                                                    patientDetails={this.props.patientDetails}
                                                    doctorInfo={this.props.doctorProfile}
                                                    savePrescriptionNew={this.props.savePatientPlan}
                                                    ongoingConsultation={this.props.ongoingConsultation}
                                                    prescriptionSaveError={this.state.prescriptionSaveError}
                                                    pdfData={this.state.pdfData}
                                                    pdfPreviewData={this.state.pdfPreviewData}
                                                    isPdfDataSaved={this.state.isPdfDataSaved}
                                                    toggleModal={this.toggleModal}
                                                    updateAppointmentStatus={this.props.updateAppointmentStatus}
                                                    uploadPrescription={this.props.uploadPrescription}
                                                    onPrescriptionSaveSuccess={this.onPrescriptionSaveSuccess}
                                                    savePrescription={this.props.saveCurrentPrescription}
                                                    showDifferentialDiagnosisModal={
                                                        this.showDifferentialDiagnosisModal
                                                    }
                                                    planSaveError={this.state.planSaveError}
                                                    uploadPlan={this.props.uploadPlan}
                                                    onPlanSaveSuccess={this.onPlanSaveSuccess}
                                                    errorMessage={
                                                        AppUtils.isDefined(this.state.errorMessage)
                                                            ? this.state.errorMessage
                                                            : this.state.isPdfDataSaved
                                                                ? AppMessages.PRESCRIPTION_PDF_SAVE_FAILURE
                                                                : AppMessages.SAVE_PRESCRIPTION_UNSUCCESSFUL
                                                    }
                                                    saveUserPlan={this.props.savePatientPlan}
                                                    isOnlyErrorModal={AppUtils.isDefined(
                                                        this.state.errorMessage
                                                    )}
                                                    removeWorkflowObject={this.props.removeWorkflowObject}
                                                />
                                            )}
                                        {modalScreen === MODAL_SCREENS["4"] && (
                                            <PrivateNotesModal
                                                appointmentId={this.getConsultationId()}
                                                patientId={this.getPatientId()}
                                                bookingId={this.getBookingId()}
                                                patientDifferentialDiagnosis={differentialDiagnosisObject}
                                                saveDifferentialDiagnosis={this.saveDifferentialDiagnosis}
                                                showLoginPrompt={this.showLogoutPrompt}
                                                patientDetails={this.props.patientDetails}
                                                ongoingConsultation={this.props.ongoingConsultation}
                                                updateAppointmentStatus={this.props.updateAppointmentStatus}
                                                updatePatientMedicalProfile={this.props.updatePatientMedicalProfile}
                                                getMedicalProfile={this.props.getMedicalProfile}
                                                doctorType={doctorType}
                                                fetchOngoingConsultation={this.props.fetchOngoingConsultation}
                                                curefitUserId={this.getCurefitUserId()}
                                            />
                                        )}
                                        {modalScreen === MODAL_SCREENS["8"] && (
                                            <div className={"saving-pdf-modal"}>
                                                <span>
                                                    <img src={ORION_IMG_URL + "loader/rolling-loader.gif"} />
                                                    <div>Saving PDF</div>
                                                </span>
                                            </div>
                                        )}
                                        {modalScreen === MODAL_SCREENS["9"] && (
                                            <LogoutPrompt
                                                navigateToDashboard={this.navigateToDashboard}
                                            />
                                        )}
                                        {modalScreen === MODAL_SCREENS["10"] && <CompleteConsultConfirmation
                                            closeModal={this.closeModal}
                                            handleCompleteClick={this.handleConfirmCompleteClick}
                                        />}
                                        {modalScreen === MODAL_SCREENS["11"] && <EndLCConsultation
                                            closeModal={this.closeModal}
                                            appointmentId={this.getConsultationId()}
                                            doctorProfile={this.props.doctorProfile}
                                            doctorType={doctorType}
                                            patientId={this.getCurefitUserId()}
                                            secondaryUserId={this.getPatientId().toString()}
                                            bookingId={this.getBookingId()}
                                            ongoingConsultation={this.props.ongoingConsultation}
                                            saveUserPlan={this.props.savePatientPlan}
                                            updateAppointmentStatus={this.props.updateAppointmentStatus}
                                        />}
                                    </ModalComponent>
                                )}
                                {this.state.secondModal && (
                                    <ModalComponent modalSize={""}>
                                        <PdfSaveSuccessModal
                                            consultationId={this.getConsultationId()}
                                            patientDetails={this.props.patientDetails}
                                            ongoingConsultation={this.props.ongoingConsultation}
                                            pdfData={this.state.pdfPreviewData}
                                            toggleModal={this.toggleModal}
                                            showDifferentialDiagnosisModal={
                                                this.showDifferentialDiagnosisModal
                                            }
                                            printPdf={this.handlePdfPrint}
                                            userId={Number(userId)}
                                            uploadPdf={this.handleUploadPdf}
                                            savePrescriptionAsTemplate={this.savePrescriptionAsTemplate}
                                            isTreatmentPlanEnabled={
                                                this.props.featureConfigInfo["OrionEnablePrescriptionTemplate"]
                                                    ? this.props.featureConfigInfo["OrionEnablePrescriptionTemplate"] === FeatureConfigValues.TRUE
                                                    : false
                                            }
                                        />
                                    </ModalComponent>
                                )}
                                <ConsultationDelay triggeredIn={this.state.triggeredIn}
                                    consultation={this.props.ongoingConsultation.appointmentSchedule}
                                    hideContainer={() => this.toggleDelayContainer(false)} />

                            </div>
                        )}
                        {!isComponentLoadedCompletely && (
                            <div className="central-loader ongoing-consultation-cont-loader">
                                <img src={ORION_IMG_URL + "loader/curefit-loader.gif"} />
                            </div>
                        )}
                        {
                            this.state.consultationStartedStatusUpdateFailed &&
                            <ErrorContainer errorText={"Failed to start the consultation. Please try again."} errorCode={0} closeError={() => RouteUtils.navigateToDashboard()} />
                        }
                        {!_isEmpty(videoContext) && !AppUtils.getIsMobile() && <CheckMediaDevices />}
                    </SectionContext.Provider>
                </FlowContext.Provider>
            </div>
        );
    }
}

function mapStateToProps(state: IAppState, ownProps: any): any {
    return {
        accountData: state.accountData,
        patientConditions: state.patientCompleteInfo.conditions,
        patientSurgeries: state.patientCompleteInfo.surgeryAndProcedure,
        patientAllergies: state.patientCompleteInfo.allergies,
        patientHabits: state.patientCompleteInfo.habits,
        patientCurrentMedication: state.patientCompleteInfo.currentMedication,
        patientConcerns: state.patientCompleteInfo.concerns,
        patientRedFlags: state.patientCompleteInfo.redFlags,
        ongoingConsultation: state.ongoingConsultation,
        patientDetails: state.patientCompleteInfo,
        doctorProfile: state.doctorProfile,
        patientVitals: state.patientCompleteInfo.vitals,
        patientGeneralExamination: state.patientCompleteInfo.generalExaminations,
        patientSystemicExamination: state.patientCompleteInfo.systemicExaminations,
        staticVitalList: state.allStaticDataNew.vitalList,
        staticSpecialities: state.allStaticDataNew.doctorSpecialityResponseList,
        staticMedicineTypes: state.allStaticDataNew.medicalTypeList,
        staticConditions: state.allStaticDataNew.pastConditions,
        isCovidActivePack: state.covidInfo.isCovidActivePack,
        staticRedFlags: state.allStaticDataNew.redFlags && state.allStaticDataNew.redFlags.values,
        staticPersonalInfo: state.allStaticDataNew.personalInformation,
        staticPersonalInfoPhysiotherapist:
            state.allStaticDataNew.personalInformationPhysiotherapist,
        staticMindfulnessInfo: state.allStaticDataNew.mindfulnessInformation,
        staticFitnessRecallInfo: state.allStaticDataNew.fitnessRecallInformation,
        staticFoodTypes: state.allStaticDataNew.staticDietRecallData
            ? state.allStaticDataNew.staticDietRecallData.allPreferredFoodTypes.values
            : null,
        staticCuisines: state.allStaticDataNew.staticDietRecallData
            ? state.allStaticDataNew.staticDietRecallData.allPreferredCuisines.values
            : null,
        routineActivities: state.allStaticDataNew.routineActivities,
        staticPatientHabits: state.allStaticDataNew.habits,
        staticGeneralExams: state.allStaticDataNew.generalExaminations && state.allStaticDataNew.generalExaminations.values,
        staticSystemicExams: state.allStaticDataNew.systemicExaminations && state.allStaticDataNew.systemicExaminations.values,
        staticEntExams: state.allStaticDataNew.entExaminations && state.allStaticDataNew.entExaminations.values,
        staticMentalStatusExaminations: state.allStaticDataNew.mentalStatusExaminations && state.allStaticDataNew.mentalStatusExaminations.values,
        staticReviewSystemsData: state.allStaticDataNew.reviewOfSystems && state.allStaticDataNew.reviewOfSystems.values,
        chatAndVideoAccessTokens: state.chatAndVideoAccessTokens,
        pastConsultations: state.patientCompleteInfo.consultations,
        staticFoodGroups: state.allStaticDataNew.foodGroups,
        patientTypeFormData: state.patientCompleteInfo.typeFormData,
        typeFormMapping: state.allStaticDataNew.typeFormMapping,
        connectionStrengthMessage: state.twilioContext.connectionStrengthMessage,
        staticLifestyleHabits: state.allStaticDataNew.lifestylePlanHabits,
        staticGoals: state.allStaticDataNew.goals,
        staticMetrics: state.allStaticDataNew.metrics,
        staticTrackableSymptoms: state.allStaticDataNew.trackableSymptoms,
        uiConfiguration: state.ongoingConsultation.uiConfiguration,
        labTests: state.ongoingConsultation.patientLabTests,
        diagnosticLabTests: state.ongoingConsultation.diagnosticLabTests,
        manualLabTests: state.ongoingConsultation.manualLabTests,
        staticPatientPlanEligibilityMaskAnswers: state.allStaticDataNew.staticPatientPlanEligibilityMaskAnswers,
        responseData: state.responseData.status,
        modalResponse: state.responseData,
        pdfTemplates: state.ongoingConsultation.pdfTemplates,
        suggestions: state.ongoingConsultation.suggestions,
        consultationChannel: state.ongoingConsultation && state.ongoingConsultation.appointmentSchedule && state.ongoingConsultation.appointmentSchedule.channel,
        featureConfigInfo: state.featureConfigInfo,
        allAppointments: state.appointments,
        whatsAppChatContext: state.whatsAppChatContext
    }
}

function mapDispatchToProps(dispatch: any): any {
    return {
        fetchPatientCompleteDetails: (patientId: number) => {
            return PatientCompleteInfoActions.fetchPatientCompleteDetails(
                dispatch,
                patientId
            );
        },
        fetchOngoingConsultation: (appointmentId: number, patientId: number, userId: number, isSelf: boolean, doctorProfile: IDoctorProfile) => {
            return OngoingConsultationActions.fetchOngoingConsultationDetails(dispatch, patientId, appointmentId, userId, isSelf, doctorProfile); // @todo: remove hardcoding here
        },
        fetchPatientPastSessions: (patientId: number, subSectionKey: string) => {
            return PatientCompleteInfoActions.fetchPatientPastSessions(
                dispatch,
                patientId,
                subSectionKey
            );
        },
        fetchVideoContext: (appointmentId: number, commUserId: number) => {
            return OngoingConsultationActions.fetchVideoContext(
                dispatch,
                appointmentId,
                commUserId
            );
        },
        fetchChatContext: (appointmentId: number, commUserId: number) => {
            return OngoingConsultationActions.fetchChatContext(
                dispatch,
                appointmentId,
                commUserId
            );
        },

        closeWhatsAppChat: () => {
            return dispatch(WhatsAppChatActions.closeWhatsAppChat());
        },

        updateWhatsAppChatContext: (patientInfo: WhatsAppPatientInfo) => {
            return dispatch(WhatsAppChatActions.updateWhatsAppPatientInfo(patientInfo));
        },

        saveEditedPatientGoals: (patientGoals: UserGoalView[]) => {
            return dispatch(
                OngoingConsultationActions.saveEditedPatientGoals(patientGoals)
            );
        },
        saveEditedPatientSecondaryGoals: (
            patientSecondaryGoals: UserGoalView[]
        ) => {
            return dispatch(
                OngoingConsultationActions.updateCurrentPatientSecondaryGoals(
                    patientSecondaryGoals
                )
            );
        },

        saveEditedPatientInterventions: (
            patient_interventions: UserGoalView[]
        ) => {
            return dispatch(
                OngoingConsultationActions.updateCurrentPatientSecondaryGoals(
                    patient_interventions
                )
            );
        },
        saveEditedPrescription: (prescription: IPrescription) => {
            return dispatch(
                OngoingConsultationActions.updateCurrentPrescription(prescription)
            );
        },
        saveEditedAllergies: (allergies: IPatientAllergy[]) => {
            return dispatch(
                OngoingConsultationActions.updateCurrentAllergies(allergies)
            );
        },
        saveEditedMedicalProfile: (medicalProfile: IEHRSavePatientMedicalProfile, subSectionKey: string, appointmentId: number) => {
            return dispatch(OngoingConsultationActions.updatePatientMedicalProfile(medicalProfile, subSectionKey, appointmentId));
        },
        saveEditedExaminations: (exams: IPatientExamination[]) => {
            return dispatch(OngoingConsultationActions.updateExaminations(exams));
        },
        saveEditedSystemicExaminations: (exams: IPatientSystemiscExamination[]) => {
            return dispatch(
                OngoingConsultationActions.updateSystemicExaminations(exams)
            );
        },
        saveEditedMentalStatusExaminations: (exams: IMentalStatusExamination[]) => {
            return dispatch(
                OngoingConsultationActions.updateMentalStatusExaminations(exams)
            );
        },
        saveEditedChiefComplaints: (chiefComplaints: ISymptom[]) => {
            return dispatch(
                OngoingConsultationActions.updateCurrentChiefComplaints(chiefComplaints)
            );
        },
        saveEditedIllnesses: (illnesses: string) => {
            return dispatch(
                OngoingConsultationActions.updateCurrentIllnesses(illnesses)
            );
        },
        saveCurrentPrescription: (
            appointmentId: number,
            prescription: IPrescription
        ) => {
            return OngoingConsultationActions.savePatientPrescription(
                dispatch,
                appointmentId,
                prescription
            );
        },
        uploadPrescription: (
            appointmentId: number,
            prescription: File,
            type: string
        ) => {
            return OngoingConsultationActions.savePatientPrescriptionPDF(
                dispatch,
                appointmentId,
                prescription,
                type
            );
        },
        uploadPlan: (appointmentId: number, patientPlan: File, type: string) => {
            return OngoingConsultationActions.savePatientPlanPDF(
                dispatch,
                appointmentId,
                patientPlan,
                type
            );
        },
        saveDifferentialDiagnosis: (
            appointmentId: number,
            differentialDiagnosis: IDifferentialDiagnosis
        ) => {
            return OngoingConsultationActions.saveDifferentialDiagnosis(
                dispatch,
                appointmentId,
                differentialDiagnosis
            );
        },
        savePrivateNotes: (appointmentId: number, privateNotes: IPrivateNotes) => {
            return OngoingConsultationActions.savePrivateNotes(
                dispatch,
                appointmentId,
                privateNotes
            );
        },
        updateAppointmentStatus: (
            bookingId: number,
            appointmentId: number,
            status: ConsultationStatusConstant
        ) => {
            return OngoingConsultationActions.updateAppointmentStatus(
                dispatch,
                bookingId,
                appointmentId,
                status
            );
        },
        fetchPatientVitals: (
            patientId: number,
            userId: number,
            metricIds: number[]
        ) => {
            return PatientCompleteInfoActions.fetchPatientVitals(
                dispatch,
                patientId,
                userId,
                metricIds
            );
        },
        savePatientVitals: (patientId: number, patientVitals: IPatientVital[]) => {
            return PatientCompleteInfoActions.savePatientVitals(
                dispatch,
                patientId,
                patientVitals
            );
        },
        fetchAllStaticData: () => {
            return AllStaticDataActions.fetchAllStaticData(dispatch);
        },
        fetchPlanStaticData: () => {
            return AllStaticDataActions.fetchPlanStaticData(dispatch);
        },
        savePatientMedicalProfile: (
            patientId: number,
            patientMedicalProfile: IEHRSavePatientMedicalProfile,
            appointmentId: number,
            doctorType: string
        ) => {
            return PatientCompleteInfoActions.savePatientMedicalProfile(
                dispatch,
                patientId,
                patientMedicalProfile,
                appointmentId,
                doctorType
            );
        },
        savePatientAllergies: (
            patientId: number,
            patientAllergies: IPatientAllergy[]
        ) => {
            return PatientCompleteInfoActions.savePatientAllergyData(
                dispatch,
                patientId,
                patientAllergies
            );
        },
        savePatientGoals: (patientId: number, patientGoals: UserGoalView[]) => {
            return OngoingConsultationActions.savePatientGoals(
                dispatch,
                patientId,
                patientGoals
            );
        },
        savePatientGoalsEdit: (patientId: number, req: any) => {
            return OngoingConsultationActions.savePatientGoalsEdit(
                dispatch,
                patientId,
                req
            );
        },
        fetchStaticDiseaseData: (input: string) => {
            return AllStaticDataActions.fetchStaticDiseaseData(input);
        },
        fetchStaticLabTestsData: (input: string) => {
            return AllStaticDataActions.fetchStaticTestsData(input);
        },
        fetchStaticSymptomsData: (input: string) => {
            return AllStaticDataActions.fetchStaticSymptomsData(input);
        },
        fetchStaticLifeStyleData: (input: string) => {
            return AllStaticDataActions.fetchStaticLifeStyleData(input);
        },
        fetchAppointmentsForPatient: (patientId: number) => {
            return AppointmentsActions.fetchAppointmentsForPatient(
                dispatch,
                patientId
            );
        },
        saveEditedPersonalProfile: (personalProfile: PatientPersonalProfile) => {
            return dispatch(
                OngoingConsultationActions.updateCurrentPersonalInfo(personalProfile)
            );
        },
        updatePatientProfileData: (
            id: string,
            personProfile: PatientPersonalProfile
        ) => {
            return OngoingConsultationActions.updatePatientProfileData(
                dispatch,
                id,
                personProfile
            );
        },
        fetchStaticRoutineAttributes: () => {
            return AllStaticDataActions.fetchStaticRoutineAttr();
        },
        forceCompleteAppointment: (
            status: string,
            bookingId: number,
            appointmentId: number,
            reasonCode: ForceCloseReason,
            reasonText: string,
            missedReasonCode?: MISSED_REASON_CODE
        ) => {
            return OngoingConsultationActions.forceCompleteAppointment(
                dispatch,
                status,
                bookingId,
                appointmentId,
                reasonCode,
                reasonText,
                missedReasonCode
            );
        },
        fetchFitnessActivitiesByName: (input: string) => {
            return LifestylePlanActions.fetchFitnessActivities(input);
        },
        fetchMindfulnessActivitiesByName: (input: string) => {
            return LifestylePlanActions.fetchMindfulnessActivities(input);
        },
        clearOngoingConsultationDetails: () => {
            return dispatch(
                OngoingConsultationActions.clearOngoingConsultationDetails()
            );
        },
        fetchStaticFoodGroups: () => {
            return AllStaticDataActions.fetchStaticFoodGroups(dispatch);
        },
        fetchMealsByCalorie: (calorieBreakup: IFetchMealsByCaloriesRequest) => {
            return AllStaticDataActions.fetchStaticMealsByCalorieBreakup(
                calorieBreakup
            );
        },
        saveAllProfilesForPatient: (
            curefitUserId: number,
            patientId: number,
            isSelf: boolean,
            allProfiles: PatientPersonalProfile
        ) => {
            return OngoingConsultationActions.saveAllProfilesForPatient(
                dispatch,
                curefitUserId,
                patientId,
                isSelf,
                allProfiles
            );
        },
        saveEditedPatientPlan: (patientPlan: IPatientLifestylePlanWrapper) => {
            return OngoingConsultationActions.updateEditedPatientPlan(patientPlan, dispatch);
        },
        savePatientPlanInDraft: (
            consultationId: number,
            patientPlan: IGenericPlanPrescriptionDetailObject[]
        ) => {
            return OngoingConsultationActions.savePatientPlanInDraft(
                dispatch,
                consultationId,
                patientPlan
            );
        },
        launchPatientPlan: (patientId: number, req: any) => {
            return OngoingConsultationActions.launchPatientPlan(
                dispatch,
                patientId,
                req
            );
        },
        launchPatientGoals: (patientId: number, req: any) => {
            return OngoingConsultationActions.launchPatientGoals(
                dispatch,
                patientId,
                req
            );
        },
        getMedicalProfile: (patientId: number, appointmentId: number, doctorType: string) => {
            return OngoingConsultationActions.getMedicalProfile(dispatch, patientId, appointmentId, doctorType);
        },
        saveReviewOfSystemsData: (data: IPatientSystemReview[]) => {
            return dispatch(OngoingConsultationActions.saveReviewOfSystemsData(data));
        },
        fetchMedicineByGenericName: (input: string) => {
            return MedicationActions.loadMedicinesByGenericName(input);
        },
        updateCurrentChannelWithPatient: (
            channelSid: string,
            patient: IPatientDetail,
            identity: string
        ) => {
            return dispatch(
                TwilioActions.updateCurrentChannelWithPatient(channelSid, patient, identity)
            );
        },
        clearCurrentChannel: () => {
            return dispatch(TwilioActions.clearCurrentChannel());
        },
        fetchDishByDishName: (input: string) => {
            return AllStaticDataActions.fetchStaticDishesByDishName(input);
        },
        fetchMealByMealId: (mealId: string) => {
            return AllStaticDataActions.fetchMealByMealId(mealId);
        },
        previewMeal: (meal: IMealItem) => {
            return AllStaticDataActions.previewMeal(meal);
        },
        createMeal: (meal: IMealItem) => {
            return AllStaticDataActions.createMeal(meal);
        },
        fetchStaticDietGuidelines: (input: string, category: string) => {
            return AllStaticDataActions.fetchStaticDietGuidelines(input, category);
        },
        saveEditedPatientTrackableSymptoms: (
            trackableSymptoms: UserTrackableSymptomUpsertRequest[]
        ) => {
            return dispatch(
                OngoingConsultationActions.saveEditedPatientTrackableSymptoms(
                    trackableSymptoms
                )
            );
        },
        savePatientTrackableSymptoms: (
            userId: number,
            reqData: UserTrackableSymptomUpsertRequest[]
        ) => {
            return OngoingConsultationActions.savePatientTrackableSymptoms(
                dispatch,
                userId,
                reqData
            );
        },
        deletePatientTrackableSymptoms: (
            userId: number,
            reqData: UserTrackableSymptomUpsertRequest[]
        ) => {
            return OngoingConsultationActions.deletePatientTrackableSymptoms(
                dispatch,
                userId,
                reqData
            );
        },
        addUserMetric: (
            userId: string,
            patientId: number,
            isSelf: boolean,
            metricId: string,
            metricValue: number
        ) => {
            return OngoingConsultationActions.addUserMetric(
                dispatch,
                userId,
                patientId,
                isSelf,
                metricId,
                metricValue
            );
        },
        getUserMetrics: (req: IMetricOptions) => {
            return OngoingConsultationActions.getUserMetrics(dispatch, req);
        },
        savePatientMedicalProfileSuccess: (
            patientId: number,
            patientMedicalProfile: IEHRSavePatientMedicalProfile
        ) => {
            return PatientCompleteInfoActions.savePatientMedicalProfileSuccess(
                patientId,
                patientMedicalProfile
            );
        },
        orionClientLogger: (err: any) => {
            return OngoingConsultationActions.clientLogger(err);
        },
        savePatientPlan: (
            consultation: IAppointmentScheduleResponse,
            prescription: IPrescription,
            patientPlan: IPatientLifestylePlanWrapper,
            planId: string,
            isSelf?: boolean,
            medicalProfile?: any
        ) => {
            return OngoingConsultationActions.savePatientPlanNew(
                consultation,
                prescription,
                patientPlan,
                planId,
                ConsultationStatusConstant.PRESCRIPTION_GENERATED,
                isSelf,
                medicalProfile
            );
        },
        removeWorkflowObject: (
            consultation: IAppointmentScheduleResponse,
            isPrescriptionObject: boolean
        ) => {
            return OngoingConsultationActions.removeWorkflowObject(
                consultation,
                isPrescriptionObject
            );
        },

        fetchStaticDiagnosticLabTests: (input: string) => {
            return AllStaticDataActions.fetchStaticDiagnosticLabTests(input);
        },
        savePatientDiagnosticLabTests: (
            requestparameters: ILabtestPrescription[]
        ) => {
            return PatientCompleteInfoActions.savePatientDiagnosticLabTests(
                dispatch,
                requestparameters
            );
        },

        savePatientLabTestsSuccess: (dataObject: any) => {
            return PatientCompleteInfoActions.savePatientLabTestsSuccess(dataObject);
        },
        savePatientLabTests: (patientLabTests: any) => {
            return dispatch(
                PatientCompleteInfoActions.savePatientLabTests(patientLabTests)
            );
        },
        saveEditedPatientLabTests: (diagnosticLabTests: any) => {
            return dispatch(
                OngoingConsultationActions.updateEditedPatientLabTests(
                    diagnosticLabTests
                )
            );
        },
        updateDiagnosticLabTests: (diagnosticLabTests: any) => {
            return OngoingConsultationActions.updateDiagnosticLabTests(
                diagnosticLabTests
            );
        },
        saveManualLabTests: (labTests: IDiagnosticLabTestItem[]) => {
            return OngoingConsultationActions.saveManualLabTests(dispatch, labTests);
        },
        updatePatientPlanEligibilityMasks: (
            userId: String,
            secondaryUserId: String,
            isSelf: Boolean,
            eligibilityMasks: String[]
        ) => {
            return OngoingConsultationActions.updatePatientPlanEligibilityMasks(
                dispatch,
                userId,
                secondaryUserId,
                isSelf,
                eligibilityMasks
            );
        },
        deletePatientDiagnosticLabTests: (deletedLabTestIds: number[]) => {
            return PatientCompleteInfoActions.deletePatientDiagnosticLabTests(dispatch, deletedLabTestIds);
        },
        addSymptomForReview: (name: string) => {
            return OngoingConsultationActions.addSymptomForReview(dispatch, name);
        },
        fetchConsultationPdfTemplates: (appointmentSchedule: IAppointmentScheduleResponse) => {
            return OngoingConsultationActions.fetchConsultationPdfTemplates(dispatch, appointmentSchedule)
        },
        fetchPastConsultationData: (consultationId: string, doctorType: string, patientId: string) => {
            return PatientCompleteInfoActions.fetchPastConsultationData(dispatch, consultationId, doctorType, patientId)
        },
        updateCurrentConsultationData: (medicalProfile: IEHRSavePatientMedicalProfile) => {
            return dispatch(OngoingConsultationActions.updateCurrentConsultationData(medicalProfile))
        },
        fetchDataOnSelect: (doctorId: number, diagnosis?: Array<string>) => {
            OngoingConsultationActions.fetchTreatmentPlanSuggestions(dispatch, doctorId, diagnosis)
        },
        getTreatmentPlans: (doctorId: number) => {
            TreatmentPlanActions.fetchAllTreatmentPlanTemplates(doctorId, dispatch);
        },
        getIsActiveCovidPack: (userId: number) => {
            return OngoingConsultationActions.getIsActiveCovidPack(dispatch, userId)
        },
        getConsultationFeedbackUserFormData: (userId: number) => {
            return getConsultationFeedbackFormData(dispatch, userId);
        },
        fetchDoctorAppointments: (doctorId: number, startTimeEpoch: number, numOfDays: number, isForPoll?: boolean, tillTimeEpoch?: number) => {
            return AppointmentsActions.fetchDoctorAppointment(dispatch, doctorId, startTimeEpoch, numOfDays, isForPoll, tillTimeEpoch)
        },
        fetchAccessPolicyForCurrentUser: (ConsentParams: ConsentParam) => OngoingConsultationActions.fetchAccessPolicyForCurrentUser(ConsentParams.principleReferenceEntity, ConsentParams.ownerReferenceEntity, ConsentParams.ownerReferenceEntityId, ConsentParams.resourceType, ConsentParams.principleReferenceEntityId),

        setAccessPolicyForCurrentUser: (consentParams: ConsentParam) => OngoingConsultationActions.setAccessPolicyForCurrentUser(consentParams)
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OngoingConsultationContainer)
